import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
// Import currency_list for use in getCurrencyObjectFromCurrencyCode function
import { currency_list as currencyList } from './constants/currencyList'

export const APP_CONSTANTS = {
  LIVE_APP_URL: 'https://aumhum.com',
  BETA_APP_URL: 'https://health.aumhum.xyz',
  SOCIAL_SHARE_BASE_URL: 'https://manage.aumhum.com',
  APP_TERMS_URL: 'https://aumhum.com/terms',
  APP_PRIVACY_POLICY_URL: 'https://aumhum.com/privacy-policy',
  // API_CALLS_DOMAIN: 'https://live.aumhum.xyz',
  API_CALLS_DOMAIN: 'https://manage.aumhum.com',
  PUBLIC_API_CALLS_DOMAIN: 'https://papi.aumhum.com',
  API_CALLS_PRE_PRD_DOMAIN: 'https://manage.aumhum.com', // Change this to your server URL
  APP_CALLS_ALTERNATIVE_DOMAIN: 'https://dev.aumhum.xyz',
  API_CALLS_KEDAR: 'http://172.16.0.206:8080/aumhum',
  MEDIA_URL: 'https://media.aumhum.com/images/prod/',
  MENTOR_HOME_PUBLIC_PAGE_IMAGE_ID: 'MEDIA-e125f548acb74bb4b4011369b4610c54',
  APP_DOWNLOAD_QR: 'MEDIA-36648222b9c547b59f5a59ab37c930c5',
  SWISH_CLUB_LOGO: 'MEDIA-b52f7530958c4a97bb3e6b5f6db90e22',
  MENTOR_HOME_PUBLIC_PAGE_FLEXIBLE_SCHEDULE_IMAGE: 'MEDIA-5e9d6cb0b58547078cb00375d17ee0d9',
  MENTOR_HOME_PUBLIC_PAGE_THERAPY_IMAGE: 'MEDIA-458c7c977a0e4203a0d9e37126723659',
  BUSINESS_PUBLIC_PAGE_IMAGE_ID: 'MEDIA-a7f2c13444ad41c0ae59670f1b5f8001',
  BUSINESS_PUBLIC_PAGE_TEAM_IMAGE: 'MEDIA-2e918451b4ac4c41b6c65080c223d31f',
  BUSINESS_PUBLIC_PAGE_TEAM_IMAGE_TWO: 'MEDIA-997aaf1f37d54346bc65c1a64baa4ef2',
  CLINIC_PUBLIC_PAGE_MAIN_IMAGE: 'MEDIA-1224c2b66cf142d6b22a5c59661f4ec8',
  CLINIC_PUBLIC_PAGE_SCHEDULE_IMAGE: 'MEDIA-21bc72d7e274484586482ebc724db264',
  APP_LOGO_MEDIA_ID: 'MEDIA-e8bd40c2af6e4d49b4d2aef2613c3234',
  MEDICAL_BOARD_IMAGE_LINK:
    'https://media.aumhum.com/images/prod/MEDIA-8e0be3bad9fc445b8da74d7d57360a5a',
  PODCASTS_IMAGE_LINK:
    'https://media.aumhum.com/images/prod/MEDIA-26556ca2934148029285d97c94d8ddb4',
  CONTROL_CENTER_LINK: 'https://controlcenter.aumhum.com',
  SUPPORT_EMAIL: 'namaste@aumhum.com',
  THERAPISTS_PSYCHIATRISTS_LISTING_PAGE_URL: '/therapy-psychiatry',
  PLAY_STORE_APP_LINK: 'https://play.google.com/store/apps/details?id=com.aumhum.aumhum',
  APP_STORE_APP_LINK: 'https://apps.apple.com/in/app/aumhum-meditate-breathe/id1474055225',
  SUPPORT_SCHEDULE_CALL:
    'https://aumhum.com/mentor/somya/events/EVT-73f56b6134824ad7a0d5fcdaa2d7bf68',

  DEFAULT_TITLE: 'AUMHUM - Personalized Psychiatry and Psychosomatic Care',
  DEFAULT_KEYWORDS: ['Mental Health', 'AUMHUM', 'Therapy', 'Counselling', 'Psychiatry'],
  DEFAULT_DESCRIPTION:
    'AI-driven mental health solutions to clinics, pharmacies, and emerging markets.',
  SWISH_CLUB_CODE_REDEEM_VIDEO_LINK: 'https://www.youtube.com/watch?v=V96T8y5Wd1E',
  THERAPY_SUPPORT_WHATSAPP_LINK: 'https://wa.me/916360903465',
  // Patient-facing WhatsApp number — mirrors the server-side constant
  // `twilioWhatsappFromPhoneNumberForPatients` so the same number receives
  // /care/start lead conversations and the existing Twilio WhatsApp flow.
  PATIENT_CARE_WHATSAPP_NUMBER: '916360903396',
  PATIENT_CARE_WHATSAPP_LINK: 'https://wa.me/916360903396',
}

// Build APP_LOGO_LINK from MEDIA_URL and APP_LOGO_MEDIA_ID
APP_CONSTANTS.APP_LOGO_LINK = `${APP_CONSTANTS.MEDIA_URL}${APP_CONSTANTS.APP_LOGO_MEDIA_ID}`

export const ROLE_TYPES = {
  roleUser: 'ROLE_USER',
  roleClinicAssistant: 'ROLE_CLINIC_ASSISTANT',
  roleProfessionalUser: 'ROLE_PROFESSIONAL_USER',
  roleCreator: 'ROLE_CREATOR',
  roleTeacher: 'ROLE_TEACHER',
  roleTherapist: 'ROLE_THERAPIST',
  roleDoctor: 'ROLE_DOCTOR',
  roleBusinessProspect: 'ROLE_BUSINESS_PROSPECT',
  roleBusinessCustomer: 'ROLE_BUSINESS_CUSTOMER',
  roleAdmin: 'ROLE_ADMIN',
  roleDeveloper: 'ROLE_DEVELOPER',
  roleAppManager: 'ROLE_APP_MANAGER',
  roleClinicProspect: 'ROLE_CLINIC_PROSPECT',
  roleClinicManager: 'ROLE_CLINIC_MANAGER',
  roleClinicOwner: 'ROLE_CLINIC_OWNER',
  rolePharmacist: 'ROLE_PHARMACIST',
}
export const defaultBgImgId = 'MEDIA-1735d56eebb243dc8c2fa25b59e797ad'
export const defaultColor = '#5C4544'

export const unSupportedItemTypes = [
  'moon_card',
  'plan',
  'planItem',
  'sun_card',
  'quote',
  'activity-plan',
] // not supported at all, removing from data from reaching UI
export const supportedTileV2ItemTypes = ['activity-plan', 'article', 'userMeditation'] // item types for which V2 UI is to be used

export const ALL_TILE_ITEM_TYPES = {
  activityPlan: 'activity-plan',
  article: 'article',
  userMeditation: 'userMeditation',
}

export const API_PARAM_STRINGS = {
  acquisitionModes: 'acquisition-modes',
  activity: 'activity',
  activityPlan: 'activity-plan',
  agreement: 'agreement',
  article: 'article',
  assessment: 'assessment',
  badge: 'badge',
  breathe: 'breathe',
  backgroundMusic: 'background-music',
  cacheEvict: 'cache-evict',
  clinic: 'clinic',
  clinicAssistant: 'clinic-assistant',
  clinicBrand: 'clinic-brand',
  clinicChamber: 'clinic-chamber',
  cmsUsers: 'cms-users',
  consumerSubscriptionPlan: 'consumer-subscription-plan',
  courseCmsFieldType: 'course-cms-field-type',
  diagnosis: 'diagnosis',
  displayMessageTemplates: 'display-msg-template',
  drugInfo: 'drug-info',
  faqCategory: 'faq-category',
  faqScope: 'faq-scope',
  faqs: 'faqs',
  focusArea: 'focus-area',
  healthComplaint: 'health-complaint',
  hint: 'hint',
  imageTypes: 'image-types',
  inAppMessages: 'in-app-messages',
  journal: 'journal',
  mentalState: 'mental-state',
  mentalStateType: 'mental-state-type',
  mentor: 'mentor',
  metaCategoryType: 'meta-category-type',
  metaTabSetting: 'meta-tab-setting',
  notifications: 'push-notification-template',
  oohMsg: 'ooh-msg',
  onboardingPolicy: 'onboarding-policy',
  onboardingType: 'onboarding-type',
  onlineCourse: 'course',
  paywalls: 'paywall',
  paymentGatewaySKU: 'payment-gateway-sku',
  paymentGateways: 'payment-gateway',
  planBundlePack: 'plan-bundle-pack',
  planGroups: 'meta_subscription_plan_grps',
  planPhase: 'plan-phase',
  practice: 'practice',
  prescriptionTemplate: 'prescription-template',
  quote: 'quote',
  reflection: 'reflection',
  rest: 'rest',
  satelliteCall: 'satellite-call',
  segment: 'segment',
  sentinelCard: 'sentinel-card',
  subscriptionPlan: 'subscription-plan',
  subscriptionPlanType: 'subscription-plan-type',
  supportStaff: 'support-staff',
  tab: 'tab',
  tag: 'tag',
  technique: 'technique',
  tilePolicy: 'tile-policy',
  tiles: 'tiles',
  timeSlots: 'timeslots',
  userStats: 'user-stats',
  users: 'end-users',
  webinar: 'webinar',
  courseApprovalFeedback: 'course-approval-feedback',
  approvalRequest: 'approval-request',
  courseDraft: 'course-draft',
  unPublishRequest: 'unpublish-request',
  medicalBoardMember: 'medical-board-member',
  guest: 'guest',
  supportUser: 'support-user',
}

export const COURSE_DRAFT_STATUS_TYPES = {
  active: 'active',
  stashed: 'stashed',
  submittedSoInActive: 'submitted-so-inactive',
}

export const WEBSITE_VIEW_TYPES = {
  default: 'default',
  webview: 'webview',
}

export const CUSTOMIZED_TILE_ITEM_TYPES = {
  [ALL_TILE_ITEM_TYPES.activityPlan]: 'activityPlan',
}

export const NOTIFICATION_TYPES = {
  bookedEventNotification: 'booked_event_notification',
  generic: 'generic',
  course: 'course',
  activityPlan: 'activity-plan',
}

export const ALL_SUPPORTED_CATEGORY_TYPES_V2 = {
  activePlans: 'activePlans',
}

export const TILE_CARD_VIEW_TYPES = {
  default: 'default',
  locked: 'locked',
}

export const TILE_LAYOUT_TYPE = {
  squareMid: 'square_mid',
  spreadBoard: 'spread_board',
  articleLayout: 'article_layout',
}

export const EXTERNAL_FEATURE_TYPES = {
  activityPlan: 'activity-plan',
}

export const APP_HEADER_DATA = {
  image: 'https://media.aumhum.com/images/prod/MEDIA-45abbfb5b7654bfeb6a516a6a4b687d2',
  sectionOne: {
    heading: 'Self Care',
    links: [
      { name: 'Mental Health Tests', link: '/assessment', type: 'relative' },
      {
        name: 'De-Addiction Plan',
        link: '/personalized-plan/behavioral-addiction-plan',
        type: 'relative',
      },
      { name: 'Mindfulness and Meditations', link: '/c/meditation', type: 'relative' },
      { name: 'Podcasts', link: '/podcast', type: 'relative' },
      { name: 'Articles and Readings', link: '/article', type: 'relative' },
      { name: 'CBT Journals', link: '/journal', type: 'relative' },
      { name: 'Gift AUMHUM', link: '/gift', type: 'relative' },
      // { name: 'Plans', link: '/plan', type: 'relative' },
    ],
  },
  sectionTwo: {
    heading: 'Therapy',
    links: [
      { name: 'Individual Therapy', link: '/therapy-psychiatry', type: 'relative' },
      { name: 'Couples Therapy', link: '/therapy-psychiatry', type: 'relative' },
      { name: 'Neurofeedback Therapy', link: '/therapy-psychiatry', type: 'relative' },
      { name: 'Sex Therapy', link: '/therapy-psychiatry', type: 'relative' },
      { name: 'Trauma Informed Therapy', link: '/therapy-psychiatry', type: 'relative' },
      { name: 'Mindfulness Based CBT', link: '/therapy-psychiatry', type: 'relative' },
    ],
  },
  sectionThree: {
    heading: 'Get treatment for:',
    links: [
      { name: 'Depression', link: '/therapy-psychiatry', type: 'relative' },
      { name: 'Anxiety', link: '/therapy-psychiatry', type: 'relative' },
      { name: 'Bipolar Disorder', link: '/therapy-psychiatry', type: 'relative' },
      { name: 'OCD', link: '/therapy-psychiatry', type: 'relative' },
      { name: 'PTSD', link: '/therapy-psychiatry', type: 'relative' },
      { name: 'Panic disorder', link: '/therapy-psychiatry', type: 'relative' },
    ],
  },
}

export const APP_FOOTER_DATA = {
  sectionOne: {
    heading: 'Browse Services',
    links: [
      { name: 'Find a therapist', link: '/therapy-psychiatry', type: 'relative' },
      { name: 'Anxiety', link: '/assessment/anxiety', type: 'relative' },
      { name: 'Mental Health Tests', link: '/assessment', type: 'relative' },
      { name: 'Mindfulness and Meditations', link: '/c/meditation', type: 'relative' },
      { name: 'Podcasts', link: '/podcast', type: 'relative' },
      { name: 'Articles and Readings', link: '/article', type: 'relative' },
      { name: 'CBT Journals', link: '/journal', type: 'relative' },
      {
        name: 'De-Addiction Plan',
        link: '/personalized-plan/behavioral-addiction-plan',
        type: 'relative',
      },
      // { name: 'Plans', link: '/plan', type: 'relative' },
    ],
  },
  sectionTwo: {
    heading: 'Resources',
    links: [
      {
        name: 'Join as a Mental Health Expert',
        link: '/mentors/join',
        type: 'relative',
        onClick: () => {
          localStorage.setItem('onboardingType', 'therapist')
        },
      },
      {
        name: 'Join as a Doctor',
        link: '/doctors/join',
        type: 'relative',
        onClick: () => {
          localStorage.setItem('onboardingType', 'doctor')
        },
      },
      { name: 'AUMHUM for Work', link: '/aumhum-for-workplace', type: 'relative' },
      { name: 'AUMHUM for Clinics', link: '/aumhum-for-clinics', type: 'relative' },
      {
        name: 'Cancellation and Refund',
        link: '/copy-of-privacy-policy',
        type: 'relative',
      },
      { name: 'Need Help?', link: '/help-center', type: 'relative' },
    ],
  },
  sectionThree: {
    heading: 'About',
    links: [
      {
        name: 'About AUMHUM',
        link: '/about',
        type: 'relative',
      },
      {
        name: 'AUMHUM Medical Board',
        link: '/mental-health-medical-board',
        type: 'relative',
      },
      {
        name: 'Gift AUMHUM',
        link: '/gift',
        type: 'relative',
      },
    ],
  },
}

export const supportedDailyPlayItems = [
  'course',
  'quote',
  'journal',
  'practice',
  'breathe',
  'mental-state-type',
  'assessment',
  'article',
]
export const HERO_CARD = 'heroCard'
export const LOOPED_PLAYER = 'looped_clock'
export const FALLBACK_ICON_ID = 'MEDIA-6d7825cf81bb47e8ad3eff1ead04b117'
export const FALLBACK_CARD_IMAGE = 'MEDIA-6c1f023108f44331a3b13a68015ba4d2'
export const backgroundImage = 'MEDIA-5ed709fea7a341d9b27f1d80a9a976b3'
export const advertisementImage = 'MEDIA-d387ea62fcdd4bd5a7ce666beef1a170'
export const giftCardRedeemImageId = 'MEDIA-2c7d6b3157354bbb9982eb592f146ced'
export const redirectToAppQR = 'MEDIA-ea4c4a457c9d4ff0a68bc2bf0b4ccb98'

export const GENDER_LIST = [
  {
    id: 'male',
    displayValue: 'He',
    icon: 'male_gender_icon',
    selectedIcon: 'male_gender_selected_icon',
  },
  {
    id: 'female',
    displayValue: 'She',
    icon: 'female_gender_icon',
    selectedIcon: 'female_gender_selected_icon',
  },
  {
    id: 'nonBinary',
    displayValue: 'Non-binary',
    icon: 'others_gender_icon',
    selectedIcon: 'others_gender_selected_icon',
  },
]

export const GENDER_LIST_ONBOARDING = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'nonBinary', label: 'Non-Binary' },
]

export const GENDER_LIST_OFFLINE = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'nonBinary', label: 'Other' },
]

export const BLANK_MENTOR_SCHEDULE = {
  title: 'Blank Schedule',
  defaultSchedule: true,
  // "eventIds": [],
  weeklyHourMap: {
    monday: {
      available: false,
      title: 'Monday',
    },
    tuesday: {
      available: false,
      title: 'Tuesday',
    },
    wednesday: {
      available: false,
      title: 'Wednesday',
    },
    thursday: {
      available: false,
      title: 'Thursday',
    },
    friday: {
      available: false,
      title: 'Friday',
    },
    saturday: {
      available: false,
      title: 'Saturday',
    },
    sunday: {
      available: false,
      title: 'Sunday',
    },
  },
  // "timeZone": "%2B05%3A30"
}

export const NEW_MENTOR_SCHEDULE = {
  title: 'My Schedule',
  startTime: '09:00:00',
  endTime: '17:00:00',
  // timeZone: offset,
  weeklyHourMap: {
    monday: {
      available: true,
      title: 'Monday',
      slotList: [],
    },
    tuesday: {
      available: true,
      title: 'Tuesday',
      slotList: [],
    },
    wednesday: {
      available: true,
      title: 'Wednesday',
      slotList: [],
    },
    thursday: {
      available: true,
      title: 'Thursday',
      slotList: [],
    },
    friday: {
      available: true,
      title: 'Friday',
      slotList: [],
    },
    saturday: {
      available: false,
      title: 'Saturday',
      slotList: [],
    },
    sunday: {
      available: false,
      title: 'Sunday',
      slotList: [],
    },
  },
}

export const NEW_CLINIC_SCHEDULE = [
  {
    id: '',
    title: 'Clinic Schedule ',
    weeklyHourMap: {
      sunday: {
        available: false,
        title: 'Sunday',
        slotList: null,
      },
      monday: {
        available: true,
        title: 'Monday',
        slotList: [
          {
            startTime: '09:00:00',
            endTime: '20:00:00',
          },
        ],
      },
      tuesday: {
        available: true,
        title: 'Tuesday',
        slotList: [
          {
            startTime: '09:00:00',
            endTime: '20:00:00',
          },
        ],
      },
      wednesday: {
        available: true,
        title: 'Wednesday',
        slotList: [
          {
            startTime: '09:00:00',
            endTime: '20:00:00',
          },
        ],
      },
      thursday: {
        available: true,
        title: 'Thursday',
        slotList: [
          {
            startTime: '09:00:00',
            endTime: '20:00:00',
          },
        ],
      },
      friday: {
        available: true,
        title: 'Friday',
        slotList: [
          {
            startTime: '09:00:00',
            endTime: '20:00:00',
          },
        ],
      },
      saturday: {
        available: false,
        title: 'Saturday',
        slotList: null,
      },
    },
    timeZone: '%2B05%3A30',
  },
]

export const FULL_DAY_EVERYDAY_SCHEDULE = {
  timeZone: '%2B05%3A30',
  id: 'def-full-day-everyday',
  title: 'Clinic Schedule',
  defaultSchedule: true,
  weeklyHourMap: {
    sunday: {
      available: true,
      title: 'Sunday',
      slotList: [
        {
          startTime: '00:00:00',
          endTime: '23:59:59',
        },
      ],
    },
    monday: {
      available: true,
      title: 'Monday',
      slotList: [
        {
          startTime: '00:00:00',
          endTime: '23:59:59',
        },
      ],
    },
    tuesday: {
      available: true,
      title: 'Tuesday',
      slotList: [
        {
          startTime: '00:00:00',
          endTime: '23:59:59',
        },
      ],
    },
    wednesday: {
      available: true,
      title: 'Wednesday',
      slotList: [
        {
          startTime: '00:00:00',
          endTime: '23:59:59',
        },
      ],
    },
    thursday: {
      available: true,
      title: 'Thursday',
      slotList: [
        {
          startTime: '00:00:00',
          endTime: '23:59:59',
        },
      ],
    },
    friday: {
      available: true,
      title: 'Friday',
      slotList: [
        {
          startTime: '00:00:00',
          endTime: '23:59:59',
        },
      ],
    },
    saturday: {
      available: true,
      title: 'Saturday',
      slotList: [
        {
          startTime: '00:00:00',
          endTime: '23:59:59',
        },
      ],
    },
  },
}

export const EVENT_TEMPLATE_DATA = {
  apiParam: 'event-type',
  durationInMins: 30,
  enabled: true,
  postBufferMins: 5,
  preBufferMins: 5,
  title: '',
  type: '1on1',
  free: false,
  publicEvent: true,
  defaultCurrency: '',
  defaultPrice: 0,
  // subscriptionPlanId: mentorSetupData?.oneOnOnePlans?.[0]?.id,
  panelIds: [],
  contextId: '',
  description: '',
  meetingSrc: 'aumhum',
  visitEventType: 'regular',
  meetingSrcLink: '',
}

export const DISPLAY_NAMES_OF_WEEKDAYS = {
  sunday: {
    firstLetter: 'S',
    shortName: 'Sun',
    longName: 'Sundays',
  },
  monday: {
    firstLetter: 'M',
    shortName: 'Mon',
    longName: 'Mondays',
  },
  tuesday: {
    firstLetter: 'T',
    shortName: 'Tue',
    longName: 'Tuesdays',
  },
  wednesday: {
    firstLetter: 'W',
    shortName: 'Wed',
    longName: 'Wednesdays',
  },
  thursday: {
    firstLetter: 'Th',
    shortName: 'Thu',
    longName: 'Thursdays',
  },
  friday: {
    firstLetter: 'F',
    shortName: 'Fri',
    longName: 'Fridays',
  },
  saturday: {
    firstLetter: 'Sa',
    shortName: 'Sat',
    longName: 'Saturdays',
  },
}

export const API_URL_ARRAY = [
  // { faceValue: 'LIVE', url: 'https://live.aumhum.xyz' },
  { faceValue: 'LIVE', url: 'https://manage.aumhum.com' },
  { faceValue: 'GANGA', url: 'https://ganga.aumhum.xyz' },
  { faceValue: 'STG 🔰', url: 'https://stg.aumhum.xyz' },
  { faceValue: 'DEV ⚠️', url: 'https://dev.aumhum.xyz' },
  { faceValue: 'CACHED PAPI ⚡', url: 'https://papi.aumhum.com' },
  { faceValue: 'LOCALHOST:8080 🥷', url: 'http://localhost:8080/aumhum' },
  { faceValue: 'LOCALHOST:8081 🥷', url: 'http://localhost:8081/aumhum' },
  { faceValue: 'LOCALHOST:5000 🥷', url: 'http://localhost:5000/aumhum' },
  { faceValue: 'TESTING:5000 🥷', url: 'http://192.168.1.3:5000/aumhum' },
]

export const platformOptions = [
  { id: 'aumhum', name: 'Video Call', image: 'src/assets/video_call_icon.png' },
  { id: 'offline', name: 'In Person', image: 'src/assets/video_call_icon.png' },
  { id: 'home-visit', name: 'Home Visit', image: 'src/assets/video_call_icon.png' },
]

export const SESSION_PLATFORM_ONLINE = 'aumhum'
export const SESSION_PLATFORM_OFFLINE = 'offline'
export const SESSION_PLATFORM_HOME_VISIT = 'home-visit'

export const timezones_list = [
  {
    name: '(GMT-11:00) Midway Island',
    timezone: 'Pacific/Midway',
    gmtvalue: '-11:00',
    id: 'pacific-midway',
  },
  {
    name: '(GMT-11:00) Samoa',
    timezone: 'US/Samoa',
    gmtvalue: '-11:00',
    id: 'us-samoa',
  },
  {
    name: '(GMT-10:00) Hawaii',
    timezone: 'US/Hawaii',
    gmtvalue: '-10:00',
    id: 'us-hawaii',
  },
  {
    name: '(GMT-09:00) Alaska',
    timezone: 'US/Alaska',
    gmtvalue: '-09:00',
    id: 'us-alaska',
  },
  {
    name: '(GMT-08:00) Pacific Time (US & Canada)',
    timezone: 'US/Pacific',
    gmtvalue: '-08:00',
    id: 'us-pacific',
  },
  {
    name: '(GMT-08:00) Tijuana',
    timezone: 'America/Tijuana',
    gmtvalue: '-08:00',
    id: 'america-tijuana',
  },
  {
    name: '(GMT-07:00) Arizona',
    timezone: 'US/Arizona',
    gmtvalue: '-07:00',
    id: 'us-arizona',
  },
  {
    name: '(GMT-07:00) Mountain Time (US & Canada)',
    timezone: 'US/Mountain',
    gmtvalue: '-07:00',
    id: 'us-mountain',
  },
  {
    name: '(GMT-07:00) Chihuahua',
    timezone: 'America/Chihuahua',
    gmtvalue: '-07:00',
    id: 'america-chihuahua',
  },
  {
    name: '(GMT-07:00) Mazatlan',
    timezone: 'America/Mazatlan',
    gmtvalue: '-07:00',
    id: 'america-mazatlan',
  },
  {
    name: '(GMT-06:00) Mexico City',
    timezone: 'America/Mexico_City',
    gmtvalue: '-06:00',
    id: 'america-mexico_city',
  },
  {
    name: '(GMT-06:00) Monterrey',
    timezone: 'America/Monterrey',
    gmtvalue: '-06:00',
    id: 'america-monterrey',
  },
  {
    name: '(GMT-06:00) Saskatchewan',
    timezone: 'Canada/Saskatchewan',
    gmtvalue: '-06:00',
    id: 'canada-saskatchewan',
  },
  {
    name: '(GMT-06:00) Central Time (US & Canada)',
    timezone: 'US/Central',
    gmtvalue: '-06:00',
    id: 'us-central',
  },
  {
    name: '(GMT-05:00) Eastern Time (US & Canada)',
    timezone: 'US/Eastern',
    gmtvalue: '-05:00',
    id: 'us-eastern',
  },
  {
    name: '(GMT-05:00) Indiana (East)',
    timezone: 'US/East-Indiana',
    gmtvalue: '-05:00',
    id: 'us-east-indiana',
  },
  {
    name: '(GMT-05:00) Bogota',
    timezone: 'America/Bogota',
    gmtvalue: '-05:00',
    id: 'america-bogota',
  },
  {
    name: '(GMT-05:00) Lima',
    timezone: 'America/Lima',
    gmtvalue: '-05:00',
    id: 'america-lima',
  },
  {
    name: '(GMT-04:30) Caracas',
    timezone: 'America/Caracas',
    gmtvalue: '-04:30',
    id: 'america-caracas',
  },
  {
    name: '(GMT-04:00) Atlantic Time (Canada)',
    timezone: 'Canada/Atlantic',
    gmtvalue: '-04:00',
    id: 'canada-atlantic',
  },
  {
    name: '(GMT-04:00) La Paz',
    timezone: 'America/La_Paz',
    gmtvalue: '-04:00',
    id: 'america-la_paz',
  },
  {
    name: '(GMT-04:00) Santiago',
    timezone: 'America/Santiago',
    gmtvalue: '-04:00',
    id: 'america-santiago',
  },
  {
    name: '(GMT-03:30) Newfoundland',
    timezone: 'Canada/Newfoundland',
    gmtvalue: '-03:30',
    id: 'canada-newfoundland',
  },
  {
    name: '(GMT-03:00) Buenos Aires',
    timezone: 'America/Buenos_Aires',
    gmtvalue: '-03:00',
    id: 'america-buenos_aires',
  },
  {
    name: '(GMT-03:00) Greenland',
    timezone: 'Greenland',
    gmtvalue: '-03:00',
    id: 'greenland',
  },
  {
    name: '(GMT-02:00) Stanley',
    timezone: 'Atlantic/Stanley',
    gmtvalue: '-02:00',
    id: 'atlantic-stanley',
  },
  {
    name: '(GMT-01:00) Azores',
    timezone: 'Atlantic/Azores',
    gmtvalue: '-01:00',
    id: 'atlantic-azores',
  },
  {
    name: '(GMT-01:00) Cape Verde Is.',
    timezone: 'Atlantic/Cape_Verde',
    gmtvalue: '-01:00',
    id: 'atlantic-cape_verde',
  },
  {
    name: '(GMT+00:00) Casablanca',
    timezone: 'Africa/Casablanca',
    gmtvalue: '+00:00',
    id: 'africa-casablanca',
  },
  {
    name: '(GMT+00:00) Dublin',
    timezone: 'Europe/Dublin',
    gmtvalue: '+00:00',
    id: 'europe-dublin',
  },
  {
    name: '(GMT+00:00) Lisbon',
    timezone: 'Europe/Lisbon',
    gmtvalue: '+00:00',
    id: 'europe-lisbon',
  },
  {
    name: '(GMT+00:00) London',
    timezone: 'Europe/London',
    gmtvalue: '+00:00',
    id: 'europe-london',
  },
  {
    name: '(GMT+00:00) Monrovia',
    timezone: 'Africa/Monrovia',
    gmtvalue: '+00:00',
    id: 'africa-monrovia',
  },
  {
    name: '(GMT+01:00) Amsterdam',
    timezone: 'Europe/Amsterdam',
    gmtvalue: '+01:00',
    id: 'europe-amsterdam',
  },
  {
    name: '(GMT+01:00) Belgrade',
    timezone: 'Europe/Belgrade',
    gmtvalue: '+01:00',
    id: 'europe-belgrade',
  },
  {
    name: '(GMT+01:00) Berlin',
    timezone: 'Europe/Berlin',
    gmtvalue: '+01:00',
    id: 'europe-berlin',
  },
  {
    name: '(GMT+01:00) Bratislava',
    timezone: 'Europe/Bratislava',
    gmtvalue: '+01:00',
    id: 'europe-bratislava',
  },
  {
    name: '(GMT+01:00) Brussels',
    timezone: 'Europe/Brussels',
    gmtvalue: '+01:00',
    id: 'europe-brussels',
  },
  {
    name: '(GMT+01:00) Budapest',
    timezone: 'Europe/Budapest',
    gmtvalue: '+01:00',
    id: 'europe-budapest',
  },
  {
    name: '(GMT+01:00) Copenhagen',
    timezone: 'Europe/Copenhagen',
    gmtvalue: '+01:00',
    id: 'europe-copenhagen',
  },
  {
    name: '(GMT+01:00) Ljubljana',
    timezone: 'Europe/Ljubljana',
    gmtvalue: '+01:00',
    id: 'europe-ljubljana',
  },
  {
    name: '(GMT+01:00) Madrid',
    timezone: 'Europe/Madrid',
    gmtvalue: '+01:00',
    id: 'europe-madrid',
  },
  {
    name: '(GMT+01:00) Paris',
    timezone: 'Europe/Paris',
    gmtvalue: '+01:00',
    id: 'europe-paris',
  },
  {
    name: '(GMT+01:00) Prague',
    timezone: 'Europe/Prague',
    gmtvalue: '+01:00',
    id: 'europe-prague',
  },
  {
    name: '(GMT+01:00) Rome',
    timezone: 'Europe/Rome',
    gmtvalue: '+01:00',
    id: 'europe-rome',
  },
  {
    name: '(GMT+01:00) Sarajevo',
    timezone: 'Europe/Sarajevo',
    gmtvalue: '+01:00',
    id: 'europe-sarajevo',
  },
  {
    name: '(GMT+01:00) Skopje',
    timezone: 'Europe/Skopje',
    gmtvalue: '+01:00',
    id: 'europe-skopje',
  },
  {
    name: '(GMT+01:00) Stockholm',
    timezone: 'Europe/Stockholm',
    gmtvalue: '+01:00',
    id: 'europe-stockholm',
  },
  {
    name: '(GMT+01:00) Vienna',
    timezone: 'Europe/Vienna',
    gmtvalue: '+01:00',
    id: 'europe-vienna',
  },
  {
    name: '(GMT+01:00) Warsaw',
    timezone: 'Europe/Warsaw',
    gmtvalue: '+01:00',
    id: 'europe-warsaw',
  },
  {
    name: '(GMT+01:00) Zagreb',
    timezone: 'Europe/Zagreb',
    gmtvalue: '+01:00',
    id: 'europe-zagreb',
  },
  {
    name: '(GMT+02:00) Athens',
    timezone: 'Europe/Athens',
    gmtvalue: '+02:00',
    id: 'europe-athens',
  },
  {
    name: '(GMT+02:00) Bucharest',
    timezone: 'Europe/Bucharest',
    gmtvalue: '+02:00',
    id: 'europe-bucharest',
  },
  {
    name: '(GMT+02:00) Cairo',
    timezone: 'Africa/Cairo',
    gmtvalue: '+02:00',
    id: 'africa-cairo',
  },
  {
    name: '(GMT+02:00) Harare',
    timezone: 'Africa/Harare',
    gmtvalue: '+02:00',
    id: 'africa-harare',
  },
  {
    name: '(GMT+02:00) Helsinki',
    timezone: 'Europe/Helsinki',
    gmtvalue: '+02:00',
    id: 'europe-helsinki',
  },
  {
    name: '(GMT+02:00) Istanbul',
    timezone: 'Europe/Istanbul',
    gmtvalue: '+02:00',
    id: 'europe-istanbul',
  },
  {
    name: '(GMT+02:00) Jerusalem',
    timezone: 'Asia/Jerusalem',
    gmtvalue: '+02:00',
    id: 'asia-jerusalem',
  },
  {
    name: '(GMT+02:00) Kyiv',
    timezone: 'Europe/Kiev',
    gmtvalue: '+02:00',
    id: 'europe-kiev',
  },
  {
    name: '(GMT+02:00) Minsk',
    timezone: 'Europe/Minsk',
    gmtvalue: '+02:00',
    id: 'europe-minsk',
  },
  {
    name: '(GMT+02:00) Riga',
    timezone: 'Europe/Riga',
    gmtvalue: '+02:00',
    id: 'europe-riga',
  },
  {
    name: '(GMT+02:00) Sofia',
    timezone: 'Europe/Sofia',
    gmtvalue: '+02:00',
    id: 'europe-sofia',
  },
  {
    name: '(GMT+02:00) Tallinn',
    timezone: 'Europe/Tallinn',
    gmtvalue: '+02:00',
    id: 'europe-tallinn',
  },
  {
    name: '(GMT+02:00) Vilnius',
    timezone: 'Europe/Vilnius',
    gmtvalue: '+02:00',
    id: 'europe-vilnius',
  },
  {
    name: '(GMT+03:00) Baghdad',
    timezone: 'Asia/Baghdad',
    gmtvalue: '+03:00',
    id: 'asia-baghdad',
  },
  {
    name: '(GMT+03:00) Kuwait',
    timezone: 'Asia/Kuwait',
    gmtvalue: '+03:00',
    id: 'asia-kuwait',
  },
  {
    name: '(GMT+03:00) Nairobi',
    timezone: 'Africa/Nairobi',
    gmtvalue: '+03:00',
    id: 'africa-nairobi',
  },
  {
    name: '(GMT+03:00) Riyadh',
    timezone: 'Asia/Riyadh',
    gmtvalue: '+03:00',
    id: 'asia-riyadh',
  },
  {
    name: '(GMT+03:00) Moscow',
    timezone: 'Europe/Moscow',
    gmtvalue: '+03:00',
    id: 'europe-moscow',
  },
  {
    name: '(GMT+03:30) Tehran',
    timezone: 'Asia/Tehran',
    gmtvalue: '+03:30',
    id: 'asia-tehran',
  },
  {
    name: '(GMT+04:00) Baku',
    timezone: 'Asia/Baku',
    gmtvalue: '+04:00',
    id: 'asia-baku',
  },
  {
    name: '(GMT+04:00) Volgograd',
    timezone: 'Europe/Volgograd',
    gmtvalue: '+04:00',
    id: 'europe-volgograd',
  },
  {
    name: '(GMT+04:00) Muscat',
    timezone: 'Asia/Muscat',
    gmtvalue: '+04:00',
    id: 'asia-muscat',
  },
  {
    name: '(GMT+04:00) Tbilisi',
    timezone: 'Asia/Tbilisi',
    gmtvalue: '+04:00',
    id: 'asia-tbilisi',
  },
  {
    name: '(GMT+04:00) Yerevan',
    timezone: 'Asia/Yerevan',
    gmtvalue: '+04:00',
    id: 'asia-yerevan',
  },
  {
    name: '(GMT+04:30) Kabul',
    timezone: 'Asia/Kabul',
    gmtvalue: '+04:30',
    id: 'asia-kabul',
  },
  {
    name: '(GMT+05:00) Karachi',
    timezone: 'Asia/Karachi',
    gmtvalue: '+05:00',
    id: 'asia-karachi',
  },
  {
    name: '(GMT+05:00) Tashkent',
    timezone: 'Asia/Tashkent',
    gmtvalue: '+05:00',
    id: 'asia-tashkent',
  },
  {
    name: '(GMT+05:30) Kolkata',
    timezone: 'Asia/Calcutta',
    gmtvalue: '+05:30',
    id: 'asia-kolkata',
  },
  {
    name: '(GMT+05:45) Kathmandu',
    timezone: 'Asia/Kathmandu',
    gmtvalue: '+05:45',
    id: 'asia-kathmandu',
  },
  {
    name: '(GMT+06:00) Ekaterinburg',
    timezone: 'Asia/Yekaterinburg',
    gmtvalue: '+06:00',
    id: 'asia-yekaterinburg',
  },
  {
    name: '(GMT+06:00) Almaty',
    timezone: 'Asia/Almaty',
    gmtvalue: '+06:00',
    id: 'asia-almaty',
  },
  {
    name: '(GMT+06:00) Dhaka',
    timezone: 'Asia/Dhaka',
    gmtvalue: '+06:00',
    id: 'asia-dhaka',
  },
  {
    name: '(GMT+07:00) Novosibirsk',
    timezone: 'Asia/Novosibirsk',
    gmtvalue: '+07:00',
    id: 'asia-novosibirsk',
  },
  {
    name: '(GMT+07:00) Bangkok',
    timezone: 'Asia/Bangkok',
    gmtvalue: '+07:00',
    id: 'asia-bangkok',
  },
  {
    name: '(GMT+07:00) Jakarta',
    timezone: 'Asia/Jakarta',
    gmtvalue: '+07:00',
    id: 'asia-jakarta',
  },
  {
    name: '(GMT+08:00) Krasnoyarsk',
    timezone: 'Asia/Krasnoyarsk',
    gmtvalue: '+08:00',
    id: 'asia-krasnoyarsk',
  },
  {
    name: '(GMT+08:00) Chongqing',
    timezone: 'Asia/Chongqing',
    gmtvalue: '+08:00',
    id: 'asia-chongqing',
  },
  {
    name: '(GMT+08:00) Hong Kong',
    timezone: 'Asia/Hong_Kong',
    gmtvalue: '+08:00',
    id: 'asia-hong_kong',
  },
  {
    name: '(GMT+08:00) Kuala Lumpur',
    timezone: 'Asia/Kuala_Lumpur',
    gmtvalue: '+08:00',
    id: 'asia-kuala_lumpur',
  },
  {
    name: '(GMT+08:00) Perth',
    timezone: 'Australia/Perth',
    gmtvalue: '+08:00',
    id: 'australia-perth',
  },
  {
    name: '(GMT+08:00) Singapore',
    timezone: 'Asia/Singapore',
    gmtvalue: '+08:00',
    id: 'asia-singapore',
  },
  {
    name: '(GMT+08:00) Taipei',
    timezone: 'Asia/Taipei',
    gmtvalue: '+08:00',
    id: 'asia-taipei',
  },
  {
    name: '(GMT+08:00) Ulaan Bataar',
    timezone: 'Asia/Ulaanbaatar',
    gmtvalue: '+08:00',
    id: 'asia-ulaanbaatar',
  },
  {
    name: '(GMT+08:00) Urumqi',
    timezone: 'Asia/Urumqi',
    gmtvalue: '+08:00',
    id: 'asia-urumqi',
  },
  {
    name: '(GMT+09:00) Irkutsk',
    timezone: 'Asia/Irkutsk',
    gmtvalue: '+09:00',
    id: 'asia-irkutsk',
  },
  {
    name: '(GMT+09:00) Seoul',
    timezone: 'Asia/Seoul',
    gmtvalue: '+09:00',
    id: 'asia-seoul',
  },
  {
    name: '(GMT+09:00) Tokyo',
    timezone: 'Asia/Tokyo',
    gmtvalue: '+09:00',
    id: 'asia-tokyo',
  },
  {
    name: '(GMT+09:30) Adelaide',
    timezone: 'Australia/Adelaide',
    gmtvalue: '+09:30',
    id: 'australia-adelaide',
  },
  {
    name: '(GMT+09:30) Darwin',
    timezone: 'Australia/Darwin',
    gmtvalue: '+09:30',
    id: 'australia-darwin',
  },
  {
    name: '(GMT+10:00) Yakutsk',
    timezone: 'Asia/Yakutsk',
    gmtvalue: '+10:00',
    id: 'asia-yakutsk',
  },
  {
    name: '(GMT+10:00) Brisbane',
    timezone: 'Australia/Brisbane',
    gmtvalue: '+10:00',
    id: 'australia-brisbane',
  },
  {
    name: '(GMT+10:00) Canberra',
    timezone: 'Australia/Canberra',
    gmtvalue: '+10:00',
    id: 'australia-canberra',
  },
  {
    name: '(GMT+10:00) Guam',
    timezone: 'Pacific/Guam',
    gmtvalue: '+10:00',
    id: 'pacific-guam',
  },
  {
    name: '(GMT+10:00) Hobart',
    timezone: 'Australia/Hobart',
    gmtvalue: '+10:00',
    id: 'australia-hobart',
  },
  {
    name: '(GMT+10:00) Melbourne',
    timezone: 'Australia/Melbourne',
    gmtvalue: '+10:00',
    id: 'australia-melbourne',
  },
  {
    name: '(GMT+10:00) Port Moresby',
    timezone: 'Pacific/Port_Moresby',
    gmtvalue: '+10:00',
    id: 'pacific-port_moresby',
  },
  {
    name: '(GMT+10:00) Sydney',
    timezone: 'Australia/Sydney',
    gmtvalue: '+10:00',
    id: 'australia-sydney',
  },
  {
    name: '(GMT+11:00) Vladivostok',
    timezone: 'Asia/Vladivostok',
    gmtvalue: '+11:00',
    id: 'asia-vladivostok',
  },
  {
    name: '(GMT+12:00) Magadan',
    timezone: 'Asia/Magadan',
    gmtvalue: '+12:00',
    id: 'asia-magadan',
  },
  {
    name: '(GMT+12:00) Auckland',
    timezone: 'Pacific/Auckland',
    gmtvalue: '+12:00',
    id: 'pacific-auckland',
  },
  {
    name: '(GMT+12:00) Fiji',
    timezone: 'Pacific/Fiji',
    gmtvalue: '+12:00',
    id: 'pacific-fiji',
  },
]

// currency_list moved to separate file for better performance
// Re-export for backward compatibility
export { currency_list } from './constants/currencyList'

export function getCurrencyObjectFromCurrencyCode(currencyCode) {
  // Use imported currency_list from separate file
  return currencyList.find((currency) => currency.code === currencyCode)
}

export const assessmentResultColors = [
  { startColor: '#ddd6fe', endColor: '#7c3aed' },
  { startColor: '#e9bbed', endColor: '#b71ac4' },
  { startColor: '#a3f0b7', endColor: '#04d139' },
  { startColor: '#ddd6fe', endColor: '#7c3aed' },
  { startColor: '#a3f0b7', endColor: '#04d139' },
  { startColor: '#ddd6fe', endColor: '#7c3aed' },
  { startColor: '#e9bbed', endColor: '#b71ac4' },
  { startColor: '#a3f0b7', endColor: '#04d139' },
  { startColor: '#ddd6fe', endColor: '#7c3aed' },
  { startColor: '#a3f0b7', endColor: '#04d139' },
]

export const allAvailableEventTypes = {
  oneOnOne: '1on1',
  interview: 'interview',
  consultation: 'consultation',
  therapySession: 'therapy-session',
  // Nutrition consultation rides the therapy-report pipeline as a non-psych therapy discipline;
  // the resolved discipline (resolveTherapyDiscipline) decides which EMR section set is shown
  // inside the therapy report editor.
  nutritionConsultation: 'nutrition-consultation',
  webinar: 'webinar',
  screening: 'screening',
  assessment: 'assessment',
}

export const BOOKED_EVENT_STEP_STATUSES = {
  NOT_STARTED: 'not-started',
  STARTED: 'started',
  IN_PROGRESS: 'in-progress',
  COMPLETED: 'completed',
  HANDLER_NOT_ASSIGNED: 'handler-not-assigned',
}

export const displayNamesOfEventTypes = {
  [allAvailableEventTypes?.oneOnOne]: 'One-on-one',
  interview: 'Interview Session',
  consultation: 'Consultation',
  [allAvailableEventTypes?.therapySession]: 'Therapy Session',
  webinar: 'Webinar',
  screening: 'Screening',
  assessment: 'Assessment',
}

export const RENDERING_ORDER_OF_DAYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
]

export const TABS_IN_BUSINESS_ONBOARDING = [
  { id: 'organization', title: 'Organization' },
  { id: 'plan', title: 'Plan' },
  { id: 'review', title: 'Review and Checkout' },
]

export const TABS_IN_CLINIC_LOCATION_ONBOARDING = [
  { id: 'clinic_location_details', title: 'Location Details' },
  { id: 'clinic_location_schedule', title: 'Location Schedule' },
  { id: 'clinic_location_staff', title: 'Location Staff' },
]

export const SESSION_PLANS_FOR_BUSINESS = [
  { title: '2 Live Sessions (30 mins)', price: '$29.31 PEPM', bestValue: true },
  { title: '1 Live Session (30 mins)', price: '$24.31 PEPM', bestValue: false },
  { title: 'No Live Sessions', price: '$19.31 PEPM', bestValue: false },
]

export const GROUP_SESSION_PLANS_FOR_BUSINESS = [
  { title: '2 Group Sessions', price: '$5 PEPM', bestValue: true },
  { title: '1 Group Session', price: '$7.5 PEPM', bestValue: false },
  { title: 'No Group Sessions', price: '$10 PEPM', bestValue: false },
]

export const ROLE_IN_BUSINESS_LIST = [
  { id: 'hr', title: 'Human Resources / Benefits Department' },
  { id: 'health_and_wellness', title: 'Employee Health and Wellbeing' },
  { id: 'executive', title: 'Company Executives / Senior Leadership' },
  { id: 'broker', title: 'Broker or Consultant' },
  { id: 'employee', title: 'Employee or Organization Member' },
  { id: 'other', title: 'Other Roles' },
]

export const INDUSTRY_TYPE_IN_BUSINESS_LIST = [
  { id: 'tech_and_media', title: 'Technology and Media Industry' },
  { id: 'finance_insurance_legal', title: 'Finance, Insurance, and Legal Services' },
  { id: 'business_services', title: 'Business Services Sector' },
  { id: 'education', title: 'Education Sector' },
  { id: 'non_profit_and_unions', title: 'Non-Profit Organizations and Unions' },
  { id: 'retail_and_consumer_business', title: 'Retail and Consumer Businesses' },
  { id: 'manufacturing_and_energy', title: 'Manufacturing and Energy Sector' },
  { id: 'government', title: 'Government and Public Services' },
  { id: 'sports_and_entertainment', title: 'Sports and Entertainment Industry' },
  { id: 'other', title: 'Other Industries' },
]

export const OFFLINE_PAYMENT_METHODS_LIST = [
  { id: 'cash', title: 'Cash', roleType: 'all' },
  { id: 'paytm', title: 'Paytm', roleType: 'all' },
  { id: 'google_pay', title: 'Google Pay', roleType: 'all' },
  { id: 'phone_pe', title: 'PhonePe', roleType: 'all' },
  { id: 'debit_and_credit_cards', title: 'Debit/Credit Card', roleType: 'all' },
  { id: 'other_upi', title: 'Other UPI', roleType: 'all' },
  { id: 'aumhum', title: 'Collected by AUMHUM', roleType: 'support' },
  { id: 'aumhum', title: 'Collected by Therapist', roleType: 'therapist' },
]

export const RELATIONSHIP_OPTIONS = [
  { value: 'relative', label: 'Relative' },
  { value: 'son', label: 'Son' },
  { value: 'daughter', label: 'Daughter' },
  { value: 'father', label: 'Father' },
  { value: 'mother', label: 'Mother' },
  { value: 'brother', label: 'Brother' },
  { value: 'sister', label: 'Sister' },
  { value: 'grandfather', label: 'Grandfather' },
  { value: 'grandmother', label: 'Grandmother' },
  { value: 'husband', label: 'Husband' },
  { value: 'wife', label: 'Wife' },
  { value: 'guardian', label: 'Guardian' },
  { value: 'friend', label: 'Friend' },
]

export const BLANK_PATIENT_DATA = {
  name: '',
  email: '',
  mobile: '',
  gender: 'male',
  age: null,
  ageYears: '',
  ageSecondaryValue: '',
  ageSecondaryUnit: 'months',
  note: '',
  referredBy: '',
  address: '',
  pincode: '',
  city: '',
  altMobiles: [],
  altEmails: [],
  uhId: '',
  importData: {
    importedFromId: '',
  },
  defaultCommunicationLanguage: 'en',
  attendants: [
    {
      name: '',
      primary: false,
      type: RELATIONSHIP_OPTIONS[0].value,
    },
  ],
  communicationToAttendant: false,
}

export const PATIENT_VALIDATION_FIELDS = {
  name: false,
  email: false,
  mobile: false,
  gender: false,
  age: false,
}

//deprecated export const supportedCategories = ['tabAndTile', 'course', 'tag', 'genre', 'feeling', 'technique', 'dailyFeature', 'journal', 'category', 'teacher', 'breathe', "plan"]; // obsolete

export const BUSINESS_BUNDLE_DATA = [
  {
    apiParam: 'consumer-subscription-plan',
    id: '64f32f1f3b3e4c0003cae065',
    enabled: true,
    deleted: false,
    idByUser: false,
    createdTime: '2023-09-01 11:31:55',
    modifiedTime: '2023-09-01 11:31:55',
    modifiedBy: 'USR-a5fc39fe84ab4f21b5085406290e71d0',
    planGrpId: 'businessBundle',
    internalTitle: 'enterprisePackage',
    title: 'Enterpise Version',
    description:
      'Complete care plan with virtual sessions, personalized wellness plan and a complete access to AUMHUM content library',
    subscriptionSuccessMsg: 'Your enterprise subscription is successful',
    price: 199999.0,
    discount: 199990.0,
    finalPrice: 9.0,
    currency: 'INR',
    validity: 365,
    trialDays: 0,
    recurring: false,
    autoRenew: false,
    active: true,
    preselected: false,
    subscriptionType: {
      id: 'subscription_normal',
      name: 'Premium',
    },
    corporatePackage: true,
    translations: {
      af: {
        benefits: ['', '', ''],
      },
      'sgn-US': {
        benefits: ['', '', ''],
      },
      am: {
        benefits: ['', '', ''],
      },
      ar: {
        benefits: ['', '', ''],
      },
      hy: {
        benefits: ['', '', ''],
      },
      as: {
        benefits: ['', '', ''],
      },
      bn: {
        benefits: ['', '', ''],
      },
      my: {
        benefits: ['', '', ''],
      },
      zh: {
        benefits: ['', '', ''],
      },
      cs: {
        benefits: ['', '', ''],
      },
      da: {
        benefits: ['', '', ''],
      },
      nl: {
        benefits: ['', '', ''],
      },
      en: {
        title: 'Enterpise Version',
        description:
          'Complete care plan with 2 virtual sessions per month, personalized wellness plan and a complete access to AUMHUM content library',
        subscriptionSuccessMsg: 'Your enterprise subscription is successful',
        benefits: [
          'All benefits of Premium Version, plus',
          'Custom co-branded landing page and unique URL',
          'Quarterly data insights and outcomes reports',
        ],
        idField: 'Enterpise Version',
      },
      'en-in': {
        benefits: ['', '', ''],
      },
      et: {
        benefits: ['', '', ''],
      },
      fil: {
        benefits: ['', '', ''],
      },
      fi: {
        benefits: ['', '', ''],
      },
      fr: {
        benefits: ['', '', ''],
      },
      ka: {
        benefits: ['', '', ''],
      },
      de: {
        benefits: ['', '', ''],
      },
      el: {
        benefits: ['', '', ''],
      },
      gu: {
        benefits: ['', '', ''],
      },
      he: {
        benefits: ['', '', ''],
      },
      hi: {
        benefits: ['', '', ''],
      },
      is: {
        benefits: ['', '', ''],
      },
      id: {
        benefits: ['', '', ''],
      },
      ga: {
        benefits: ['', '', ''],
      },
      it: {
        benefits: ['', '', ''],
      },
      ja: {
        benefits: ['', '', ''],
      },
      jv: {
        benefits: ['', '', ''],
      },
      kn: {
        benefits: ['', '', ''],
      },
      km: {
        benefits: ['', '', ''],
      },
      ko: {
        benefits: ['', '', ''],
      },
      ku: {
        benefits: ['', '', ''],
      },
      lo: {
        benefits: ['', '', ''],
      },
      lv: {
        benefits: ['', '', ''],
      },
      lt: {
        benefits: ['', '', ''],
      },
      mk: {
        benefits: ['', '', ''],
      },
      ms: {
        benefits: ['', '', ''],
      },
      ml: {
        benefits: ['', '', ''],
      },
      mr: {
        benefits: ['', '', ''],
      },
      mn: {
        benefits: ['', '', ''],
      },
      ne: {
        benefits: ['', '', ''],
      },
      no: {
        benefits: ['', '', ''],
      },
      or: {
        benefits: ['', '', ''],
      },
      ps: {
        benefits: ['', '', ''],
      },
      fa: {
        benefits: ['', '', ''],
      },
      pl: {
        benefits: ['', '', ''],
      },
      pt: {
        benefits: ['', '', ''],
      },
      pa: {
        benefits: ['', '', ''],
      },
      ru: {
        benefits: ['', '', ''],
      },
      sa: {
        benefits: ['', '', ''],
      },
      sr: {
        benefits: ['', '', ''],
      },
      sin: {
        benefits: ['', '', ''],
      },
      sk: {
        benefits: ['', '', ''],
      },
      es: {
        benefits: ['', '', ''],
      },
      sv: {
        benefits: ['', '', ''],
      },
      tl: {
        benefits: ['', '', ''],
      },
      ta: {
        benefits: ['', '', ''],
      },
      te: {
        benefits: ['', '', ''],
      },
      th: {
        benefits: ['', '', ''],
      },
      tr: {
        benefits: ['', '', ''],
      },
      ur: {
        benefits: ['', '', ''],
      },
      uz: {
        benefits: ['', '', ''],
      },
      vi: {
        benefits: ['', '', ''],
      },
    },
    isCorporate: true,
    benefits: [
      'All benefits of Premium Version, plus',
      'Custom co-branded landing page and unique URL',
      'Quarterly data insights and outcomes reports',
    ],
    liveSessionsPSPMPrice: 1499,
    liveSessionsPSPMMultiple: 2,
    liveSessionsPSPMMultipleDiscount: 15,
    liveSessionsPSPMMinimum: 1,
    groupSessionUnitPrice: 14999,
    groupSessionMinimum: 1,
    groupSessionMultiple: 1,
    groupSessionMultipleDiscount: 10,
    minimumSeats: 0,
    appLanguages: ['en'],
  },
  {
    id: '64f32f833b3e4c0003cae066',
    enabled: true,
    deleted: false,
    idByUser: false,
    apiParam: 'consumer-subscription-plan',
    createdTime: '2023-09-01 11:24:50',
    modifiedTime: '2023-09-01 11:24:50',
    modifiedBy: 'USR-a5fc39fe84ab4f21b5085406290e71d0',
    planGrpId: 'businessBundle',
    internalTitle: '1000PEPM',
    title: 'Enterprise Plus',
    description: 'Easy to on-board, a plan that makes sense.',
    subscriptionSuccessMsg: 'Your subscription is successful',
    price: 25000.0,
    discount: 24990.0,
    finalPrice: 10.0,
    currency: 'INR',
    validity: 365,
    trialDays: 0,
    recurring: false,
    autoRenew: false,
    active: true,
    preselected: true,
    subscriptionType: {
      id: 'subscription_normal',
      name: 'Premium',
    },
    corporatePackage: true,
    translations: {
      af: {
        benefits: ['', '', ''],
      },
      'sgn-US': {
        benefits: ['', '', ''],
      },
      am: {
        benefits: ['', '', ''],
      },
      ar: {
        benefits: ['', '', ''],
      },
      hy: {
        benefits: ['', '', ''],
      },
      as: {
        benefits: ['', '', ''],
      },
      bn: {
        benefits: ['', '', ''],
      },
      my: {
        benefits: ['', '', ''],
      },
      zh: {
        benefits: ['', '', ''],
      },
      cs: {
        benefits: ['', '', ''],
      },
      da: {
        benefits: ['', '', ''],
      },
      nl: {
        benefits: ['', '', ''],
      },
      en: {
        title: 'INR 1000 PEPM',
        description: 'Easy to on-board, a plan that makes sense.',
        subscriptionSuccessMsg: 'Your subscription is successful',
        benefits: [
          'Virtual care with dedicated therapist',
          ' Send/receive text, video, and audio messages',
          'Guaranteed daily responses 5 days/week',
        ],
        idField: 'INR 1000 PEPM',
      },
      'en-in': {
        benefits: ['', '', ''],
      },
      et: {
        benefits: ['', '', ''],
      },
      fil: {
        benefits: ['', '', ''],
      },
      fi: {
        benefits: ['', '', ''],
      },
      fr: {
        benefits: ['', '', ''],
      },
      ka: {
        benefits: ['', '', ''],
      },
      de: {
        benefits: ['', '', ''],
      },
      el: {
        benefits: ['', '', ''],
      },
      gu: {
        benefits: ['', '', ''],
      },
      he: {
        benefits: ['', '', ''],
      },
      hi: {
        benefits: ['', '', ''],
      },
      is: {
        benefits: ['', '', ''],
      },
      id: {
        benefits: ['', '', ''],
      },
      ga: {
        benefits: ['', '', ''],
      },
      it: {
        benefits: ['', '', ''],
      },
      ja: {
        benefits: ['', '', ''],
      },
      jv: {
        benefits: ['', '', ''],
      },
      kn: {
        benefits: ['', '', ''],
      },
      km: {
        benefits: ['', '', ''],
      },
      ko: {
        benefits: ['', '', ''],
      },
      ku: {
        benefits: ['', '', ''],
      },
      lo: {
        benefits: ['', '', ''],
      },
      lv: {
        benefits: ['', '', ''],
      },
      lt: {
        benefits: ['', '', ''],
      },
      mk: {
        benefits: ['', '', ''],
      },
      ms: {
        benefits: ['', '', ''],
      },
      ml: {
        benefits: ['', '', ''],
      },
      mr: {
        benefits: ['', '', ''],
      },
      mn: {
        benefits: ['', '', ''],
      },
      ne: {
        benefits: ['', '', ''],
      },
      no: {
        benefits: ['', '', ''],
      },
      or: {
        benefits: ['', '', ''],
      },
      ps: {
        benefits: ['', '', ''],
      },
      fa: {
        benefits: ['', '', ''],
      },
      pl: {
        benefits: ['', '', ''],
      },
      pt: {
        benefits: ['', '', ''],
      },
      pa: {
        benefits: ['', '', ''],
      },
      ru: {
        benefits: ['', '', ''],
      },
      sa: {
        benefits: ['', '', ''],
      },
      sr: {
        benefits: ['', '', ''],
      },
      sin: {
        benefits: ['', '', ''],
      },
      sk: {
        benefits: ['', '', ''],
      },
      es: {
        benefits: ['', '', ''],
      },
      sv: {
        benefits: ['', '', ''],
      },
      tl: {
        benefits: ['', '', ''],
      },
      ta: {
        benefits: ['', '', ''],
      },
      te: {
        benefits: ['', '', ''],
      },
      th: {
        benefits: ['', '', ''],
      },
      tr: {
        benefits: ['', '', ''],
      },
      ur: {
        benefits: ['', '', ''],
      },
      uz: {
        benefits: ['', '', ''],
      },
      vi: {
        benefits: ['', '', ''],
      },
    },
    isCorporate: true,
    benefits: [
      'Virtual care with dedicated therapist',
      ' Send/receive text, video, and audio messages',
      'Guaranteed daily responses 5 days/week',
    ],
    liveSessionsPSPMPrice: 1499,
    liveSessionsPSPMMultiple: 1,
    liveSessionsPSPMMultipleDiscount: 20,
    liveSessionsPSPMMinimum: 2,
    groupSessionUnitPrice: 24999,
    groupSessionMinimum: 0,
    groupSessionMultiple: 1,
    groupSessionMultipleDiscount: 10,
    minimumSeats: 0,
    appLanguages: ['en'],
  },
]

export const whatTimeOptions = [
  { id: 'before_dinner', title: 'Before Dinner' },
  { id: 'after_dinner', title: 'After Dinner' },
  { id: 'with_food', title: 'With Food' },
  { id: 'with_tea', title: 'With Tea' },
  { id: 'empty_stomach', title: 'Empty Stomach' },
  { id: 'bed_time', title: 'Bed Time' },
  { id: 'before_bath', title: 'Before Bath' },
  { id: 'after_bath', title: 'After Bath' },
  { id: 'before_sun', title: 'Before Sun' },
  { id: 'after_sun', title: 'After Sun' },
  { id: 'sos', title: 'SoS' },
]

export const appliedWhereOptions = [
  { id: 'on_scalp', title: 'On Scalp' },
  { id: 'on_face', title: 'On Face' },
  { id: 'on_burns', title: 'On Burns' },
  { id: 'on_wounds', title: 'On Wounds' },
  { id: 'on_warts', title: 'On Warts' },
  { id: 'on_pimples', title: 'On Pimples' },
  { id: 'on_acne', title: 'On Acne' },
  { id: 'on_scars', title: 'On Scars' },
  { id: 'on_scabies', title: 'On Scabies' },
  { id: 'on_itchy_areas', title: 'On Itchy Areas' },
  { id: 'on_rashes', title: 'On Rashes' },
  { id: 'on_dark_areas', title: 'On Dark Areas' },
  { id: 'on_dry_skin', title: 'On Dry Skin' },
  { id: 'on_wet_skin', title: 'On Wet Skin' },
  { id: 'on_ringworm', title: 'On Ringworm' },
  { id: 'on_wrinkles', title: 'On Wrinkles' },
  { id: 'on_stretch_marks', title: 'On Stretch Marks' },
]

export const frequencyOptions = [
  { id: 'daily', title: 'Daily' },
  { id: 'alternate_day', title: 'Alternate Day' },
  { id: 'weekly', title: 'Weekly' },
  { id: 'weekly_twice', title: 'Weekly Twice' },
  { id: 'weekly_thrice', title: 'Weekly Thrice' },
  { id: 'fortnight', title: 'Fortnight' },
  { id: 'monthly', title: 'Monthly' },
  { id: 'mon', title: 'Mon' },
  { id: 'tue', title: 'Tue' },
  { id: 'wed', title: 'Wed' },
  { id: 'thu', title: 'Thu' },
  { id: 'fri', title: 'Fri' },
  { id: 'sat', title: 'Sat' },
  { id: 'sun', title: 'Sun' },
]

export const timingOptions = [
  { id: '5_mins', title: '5 Mins' },
  { id: '10_mins', title: '10 Mins' },
  { id: '15_mins', title: '15 Mins' },
  { id: '20_mins', title: '20 Mins' },
  { id: '25_mins', title: '25 Mins' },
  { id: '30_mins', title: '30 Mins' },
  { id: '45_mins', title: '45 Mins' },
  { id: '60_mins', title: '1 Hr' },
]

export const unitOptions = [
  { id: 'mg', title: 'mg' },
  { id: 'ml', title: 'ml' },
  { id: 'IU', title: 'IU' },
  { id: 'g', title: 'g' },
  { id: 'ug', title: 'ug' },
  { id: 'tsp', title: 'tsp' },
  { id: 'drps', title: 'drps' },
  { id: 'units', title: 'units' },
  { id: 'tab', title: 'tab' },
  { id: 'cap', title: 'cap' },
  { id: 'puffs', title: 'puffs' },
  { id: 'vial', title: 'vial' },
]

export const DOSAGE_OPTIONS = [
  { value: '0-0-1', label: '0-0-1' },
  { value: '0-1-0', label: '0-1-0' },
  { value: '1-0-0', label: '1-0-0' },
  { value: '0-1-1', label: '0-1-1' },
  { value: '1-1-0', label: '1-1-0' },
  { value: '1-1-1', label: '1-1-1' },
  { value: '0-0-0-1', label: '0-0-0-1' },
]

export const DURATION_OPTIONS_PRESCRIPTION = [
  { value: '1 day', label: '1 day' },
  { value: '2 days', label: '2 days' },
  { value: '3 days', label: '3 days' },
  { value: '5 days', label: '5 days' },
  { value: '7 days', label: '7 days' },
  { value: '10 days', label: '10 days' },
  { value: '1 month', label: '1 month' },
  { value: '2 months', label: '2 months' },
  { value: '3 months', label: '3 months' },
]

export const NOTES_OPTIONS = [
  { value: 'at', label: 'at' },
  { value: 'at 7 pm', label: 'at 7 pm' },
  { value: 'to be taken when headache', label: 'to be taken when headache' },
  {
    value: 'to be taken when anxiety attack occurs',
    label: 'to be taken when anxiety attack occurs',
  },
  {
    value: 'to be taken only when not getting sleep',
    label: 'to be taken only when not getting sleep',
  },
  { value: 'to be taken 1 hour before sex', label: 'to be taken 1 hour before sex' },
  { value: 'to be taken just after food', label: 'to be taken just after food' },
  { value: 'to be taken only when anxiety occurs', label: 'to be taken only when anxiety occurs' },
  {
    value: 'to be taken when severe anxiety occurs',
    label: 'to be taken when severe anxiety occurs',
  },
  { value: 'to be given when agitation occurs', label: 'to be given when agitation occurs' },
  { value: 'next injection on 13/1/22', label: 'next injection on 13/1/22' },
  { value: 'to be taken half hour before food', label: 'to be taken half hour before food' },
  { value: 'TO STOP AFTER 3 MONTHS', label: 'TO STOP AFTER 3 MONTHS' },
  { value: 'STOP AFTER 10 DAYS', label: 'STOP AFTER 10 DAYS' },
  { value: 'stop after 2 months', label: 'stop after 2 months' },
  { value: 'to be taken when fever is present', label: 'to be taken when fever is present' },
  {
    value: 'to be given when dissociative attack occurs',
    label: 'to be given when dissociative attack occurs',
  },
  { value: 'TO BE TAKEN WHEN VERTIGO OCCURS', label: 'TO BE TAKEN WHEN VERTIGO OCCURS' },
  { value: 'at 8 pm', label: 'at 8 pm' },
]

export const API_SIGNATURES = {
  getBookings: '/api/secure/user/booked-slots',
}

export const FAQ_CATEGORIES = {
  my_profile_faqs: 'faq-category-9465de8a2fdd46e7897bc0507cd7820e',
  incentive_plan_faqs: 'faq-category-f1eb39a92be246a88728b5a597756194',
  event_booking_faqs: 'faq-category-bbc3330df369435086fd32b7aee8e2c9',
  therapist_booking_page_faqs: 'faq-category-c1ca53b66e75417d94cf3375fb608dbc',
  steps_to_manage_data_faqs: 'faq-category-8ab9728af6444e018f86fbe55b15ac42',
  understand_how_we_use_your_data_faqs: 'faq-category-54f4040a93f14c0db42317dc12fdbbf9',
}

export const USER_ACTIVITY_PROGRESS_LOG_TYPES = {
  autoGenerated: 'auto-generated',
  selfReported: 'self-reported',
  actuallyAttempted: 'actually-attempted',
}
export const AP_REPORT_TYPES = {
  completed: 'completed',
  userReported: 'user-reported',
}

export const TOAST_UTILS = { autoClose: 2000, newestOnTop: true, closeOnClick: true }

export const UNIQUE_COLORS_100 = [
  '#ac16d9',
  '#ec6703',
  '#26cae0',
  '#024adb',
  '#162595',
  '#1eaf11',
  '#75ad4b',
  '#57d74f',
  '#d11c50',
  '#afd9db',
  '#e81a70',
  '#3ed642',
  '#d402d6',
  '#1a6b13',
  '#80604e',
  '#eec445',
  '#da1d3d',
  '#b5e8d1',
  '#679f9a',
  '#1bb240',
  '#cf0291',
  '#91c66f',
  '#bfb51f',
  '#e1a9da',
  '#26d062',
  '#dee4cb',
  '#ac4967',
  '#14d7b5',
  '#baa1d1',
  '#0683e6',
  '#d0820e',
  '#4a1293',
  '#50580a',
  '#cfaad8',
  '#5427d1',
  '#fb94eb',
  '#3e3c20',
  '#cb2058',
  '#86bd6f',
  '#c78d13',
  '#fc1b98',
  '#5c7d47',
  '#92b1a9',
  '#e42469',
  '#9b378b',
  '#d37d92',
  '#f80805',
  '#ed3b33',
  '#331609',
  '#2f58be',
  '#870572',
  '#15bb05',
  '#1ca48e',
  '#31ffa6',
  '#9d8618',
  '#e63b2f',
  '#242f14',
  '#c1c8e0',
  '#a49a55',
  '#6847ae',
  '#a970de',
  '#40a74f',
  '#a92b8e',
  '#86818b',
  '#e27023',
  '#98c3ec',
  '#a361b0',
  '#6d3a17',
  '#cfc951',
  '#2e4e39',
  '#ee8012',
  '#42bd15',
  '#4e0246',
  '#31dbe3',
  '#60ba8a',
  '#e92996',
  '#d57ce3',
  '#fc72f6',
  '#d4cd3d',
  '#73e830',
  '#317f2b',
  '#7d1247',
  '#89849e',
  '#201b1c',
  '#f0a189',
  '#f27a34',
  '#1ee273',
  '#b9e7d6',
  '#33d83c',
  '#65aae7',
  '#9eb70b',
  '#1ac062',
  '#9fe615',
  '#06a91a',
  '#2a37a3',
  '#0f1f6f',
  '#2f3606',
  '#22ddbc',
  '#1c205b',
  '#27d540',
]

export const STRING_ID_TYPES = {
  slug: 'Slug',
  uuid: 'UUID',
}

export const HLS_TRACK_TYPES = [
  { id: 'hls_audio', title: 'Audio' },
  { id: 'hls_video', title: 'Video' },
]
export const ACTIVITY_TYPES = [
  { id: 'challenge', title: 'Challenge' },
  { id: 'plan', title: 'Plan' },
]

export const TRACK_TYPE_TO_MIME_TYPE = {
  [HLS_TRACK_TYPES?.[0]?.id]: 'audio/*',
  [HLS_TRACK_TYPES?.[1]?.id]: 'video/*',
}

export const PUBLIC_HOMEPAGE_FOUR_CARD_DESIGN_PORTRAIT_DATA = [
  {
    text: 'Practice \nanywhere, anytime — \nalways getting \ncloser to your goals  ',
    image: 'MEDIA-623515cb3df34a19a3f87391a7801d8e',
    link: '/onboarding',
    linkType: 'relative',
  },
  {
    text: 'Daily \ncheck-ins for \nmotivation & \naccountability',
    image: 'MEDIA-eda07e833d1346409abf5f91c241b502',
    link: '/onboarding',
    linkType: 'relative',
  },
  {
    text: 'Custom \nactivities designed by \nexperts \nto get your results',
    image: 'MEDIA-5f25bfdc37624c0285450cb4d5f80a3f',
    link: '/onboarding',
    linkType: 'relative',
  },
  {
    text: 'A 360° \nmental health plan\n built for you \nand your goals',
    image: 'MEDIA-07bf49e21a7a4cdab287dc6988919edb',
    link: '/onboarding',
    linkType: 'relative',
  },
]

export const PUBLIC_HOMEPAGE_FOUR_CARD_DESIGN_LANDSCAPE_DATA = [
  {
    text: 'Practice anywhere, anytime — \nalways getting closer to your goals  ',
    image: 'MEDIA-23f7b7684a6d41e9bf0756de7b8298ee',
    link: '/onboarding',
    linkType: 'relative',
  },
  {
    text: 'Daily check-ins \nfor motivation & accountability',
    image: 'MEDIA-396d0c6d0f604467abe1c672409ab302',
    link: '/onboarding',
    linkType: 'relative',
  },
  {
    text: 'Custom activities \ndesigned by experts to get your results',
    image: 'MEDIA-d6e55438067246f3ac9327a029918f07',
    link: '/onboarding',
    linkType: 'relative',
  },
  {
    text: 'A 360° mental health plan \nbuilt for you and your goals',
    image: 'MEDIA-ba026c3cceff473980915fad9fb0083e',
    link: '/onboarding',
    linkType: 'relative',
  },
]

export const ADDICTION_LANDINGPAGE_FOUR_CARD_DESIGN_PORTRAIT_DATA = [
  {
    text: 'Internet \n\nInternet addiction can \nimpact your daily life, \nrelationships, and \nmental well-being.',
    image: 'MEDIA-749b82cc5ffa40aea15dd7b3292aaebd',
    link: '/personalized-plan/behavioral-addiction-plan',
    linkType: 'relative',
  },
  {
    text: 'Gaming \n\nGaming addiction can \nlead to social isolation, \nsleep disturbances, \nand a decline in\n work performance.',
    image: 'MEDIA-ff3813e64efb4e41ac2b09af3165e9d4',
    link: '/personalized-plan/behavioral-addiction-plan',
    linkType: 'relative',
  },
  {
    text: 'Cigarette \n\nCigarette addiction not only \nharms your health \nbut also affects \nthose around you.',
    image: 'MEDIA-d8f03ec646f14e17bd6630c801b009ad',
    link: '/personalized-plan/behavioral-addiction-plan',
    linkType: 'relative',
  },
  {
    text: 'Caffeine \n\nDependence on caffeine \ncan disrupt your sleep and \n lead to physical dependence.',
    image: 'MEDIA-0a2096b90593440082d586db18950c44',
    link: '/personalized-plan/behavioral-addiction-plan',
    linkType: 'relative',
  },
]

export const ADDICTION_LANDINGPAGE_FOUR_CARD_DESIGN_LANDSCAPE_DATA = [
  {
    text: 'Internet \n\nInternet addiction can impact your daily life,\nrelationships, and mental well-being.',
    image: 'MEDIA-749b82cc5ffa40aea15dd7b3292aaebd',
    link: '/personalized-plan/behavioral-addiction-plan',
    linkType: 'relative',
  },
  {
    text: 'Gaming \n\nGaming addiction can lead to isolation, \nand a decline in work performance.',
    image: 'MEDIA-ff3813e64efb4e41ac2b09af3165e9d4',
    link: '/personalized-plan/behavioral-addiction-plan',
    linkType: 'relative',
  },
  {
    text: 'Cigarette \n\nCigarette addiction not only harms your health \nbut also affects those around you.',
    image: 'MEDIA-d8f03ec646f14e17bd6630c801b009ad',
    link: '/personalized-plan/behavioral-addiction-plan',
    linkType: 'relative',
  },
  {
    text: 'Caffeine \n\nDependence on caffeine can disrupt your sleep,\n and lead to physical dependence.',
    image: 'MEDIA-0a2096b90593440082d586db18950c44',
    link: '/personalized-plan/behavioral-addiction-plan',
    linkType: 'relative',
  },
]

export const CLINIC_TYPES = [
  { id: 'physical_clinic', title: 'Physical Clinic' },
  { id: 'cloud_clinic', title: 'Cloud Clinic' },
]

export const FEATURE_BUNDLE_TYPES_ARRAY = [
  {
    id: 'count_based',
    title: 'Usage Count Based',
  },
  {
    id: 'time_based',
    title: 'Usage Time Based',
  },
]

export const PRACTICE_TIMER_TYPES = {
  unlimited: 'unlimited',
  fixed: 'fixed',
  range: 'range',
}
export const PRACTICE_TIMER_BELL_TYPES = {
  bell: 'bell',
  none: 'none',
  vibrate: 'vibrate',
}

export const JOURNAL_OBJECT = {
  apiParam: 'journal',
  allGenre: [],
  altTexts: {
    explore: '',
    home: '',
    journal: '',
    sdk: '',
    sleep: '',
    sound: '',
    story: '',
    yoga: '',
  },
  appLanguages: ['en'],
  appListable: true,
  availableForQuote: false,
  backdropImage: '',
  backdropImageColor: '',
  blogBanner: '',
  blogBannerColor: '',
  coverIcon: '',
  coverIconColor: '',
  coverImage: '',
  coverImageColor: '',
  createdBy: '',
  customShortLink: '',
  deleted: false,
  description: '',
  enabled: true,
  endScreen: {
    animation: true,
    buttonText: '',
    message: '',
  },
  feelings: [],
  heroCardImage: '',
  heroCardImageColor: '',
  id: '',
  internalTitle: '',
  journalQusAns: [
    {
      qusId: '',
      question: 'How was your practice?',
      questionType: 'regular',
      answerType: 'textBox',
    },
  ],
  journalType: 'regular',
  postMsg: '',
  postMsgs: [],
  preMsg: '',
  preMsgs: [],
  subText: '',
  subscription: null,
  tags: [],
  title: 'New Journal',
  translations: {},
}

export const BOOKING_REQUEST_STATUS = {
  BOOKING_INITIATED: 'INITIATED',
  BOOKING_ACCEPTED: 'ACCEPTED',
  BOOKING_BOOKED: 'BOOKED',
  BOOKING_CANCELLED: 'CANCELLED',
  BOOKING_EXPIRED: 'EXPIRED',
  BOOKING_REJECTED: 'REJECTED',
}

export const AGORA_CHAT_MESSAGE_CUSTOM_EXTS_TYPE = {
  FEATURE: 'feature',
  INCOMING_BOOKING_REQUEST: 'incoming-booking-request',
  BOOKING_REQUEST_CANCELLED: 'booking-request-cancelled',
  BOOKING_REQUEST_ACCEPTED: 'booking-request-accepted',
}

export const PRESCRIPTION_TEMPLATES_TYPES = {
  onBlankSheet: 'onBlankSheet',
  onHeaderFooterPrinted: 'onHeaderFooterPrinted',
  on3QuartersPrinted: 'on3QuartersPrinted',
}

export const PRESCRIPTION_LAYOUTS = {
  default: 'default',
  threeColumnFooter: '3ColumnFooter',
  twoColumnFooter: '2ColumnFooter',
  twoColumnWithDisclaimerFooter: 'twoColumnWithDisclaimerFooter',
  twoColumnWithDisclaimerFooterWithDegreesInSeperateLines:
    'twoColumnWithDisclaimerFooterWithDegreesInSeperateLines',
  largerFontLayout: 'largerFontLayout',
  listPointersFooter: 'listPointersFooter',
  boxHeaderWithTwoColumnFooter: 'boxHeaderWithTwoColumnFooter',
  twoDoctorHeader: 'twoDoctorHeader',
  twoDoctorHeaderWithListPointers: 'twoDoctorHeaderWithListPointers',
  manasthan: 'manasthan',
}

export const PRESCRIPTION_LAYOUTS_ARRAY = [
  { id: PRESCRIPTION_LAYOUTS.default, title: 'Default' },
  { id: PRESCRIPTION_LAYOUTS.threeColumnFooter, title: '3 Column Footer' },
  { id: PRESCRIPTION_LAYOUTS.twoColumnFooter, title: '2 Column Footer' },
  {
    id: PRESCRIPTION_LAYOUTS.twoColumnWithDisclaimerFooter,
    title: 'Two column footer with disclaimer',
  },
  {
    id: PRESCRIPTION_LAYOUTS.twoColumnWithDisclaimerFooterWithDegreesInSeperateLines,
    title: 'Two column footer with disclaimer and degrees in seperate lines',
  },
  { id: PRESCRIPTION_LAYOUTS.largerFontLayout, title: 'Larger Font Layout' },
  { id: PRESCRIPTION_LAYOUTS.listPointersFooter, title: 'List Pointers Footer' },
  {
    id: PRESCRIPTION_LAYOUTS.boxHeaderWithTwoColumnFooter,
    title: 'Box Header With Two Column Footer',
  },
  {
    id: PRESCRIPTION_LAYOUTS.twoDoctorHeader,
    title: 'Two Doctor Header',
  },
  {
    id: PRESCRIPTION_LAYOUTS.twoDoctorHeaderWithListPointers,
    title: 'Two Doctor Header With List Pointers',
  },
  {
    id: PRESCRIPTION_LAYOUTS.manasthan,
    title: 'Manasthan',
  },
]

export const PRESCRIPTION_PRINT_TYPES = {
  withHeaderAndFooterData: 'withHeaderAndFooterData',
  withHeaderAndFooterBlankSpace: 'withHeaderAndFooterBlankSpace',
}

export const PRESCRIPTION_PRINT_TYPES_ARRAY = [
  { id: PRESCRIPTION_PRINT_TYPES.withHeaderAndFooterData, title: 'With header footer' },
  {
    id: PRESCRIPTION_PRINT_TYPES.withHeaderAndFooterBlankSpace,
    title: 'Blank space in header and footer',
  },
]

export const PRESCRIPTION_TEMPLATES_TYPES_ARRAY = [
  { id: PRESCRIPTION_TEMPLATES_TYPES.onBlankSheet, title: 'Blank Sheet' },
  { id: PRESCRIPTION_TEMPLATES_TYPES.onHeaderFooterPrinted, title: 'On Header Footer Printed' },
  { id: PRESCRIPTION_TEMPLATES_TYPES.on3QuartersPrinted, title: 'On 3 Quarters Printed' },
]

export const CHAMBER_SCREEN_STATES = {
  SESSION_RUNNING: 'session-running',
  IDLING: 'screen-idling',
}

export const CHAMBER_SCREEN_ACTIONS = {
  ACTION_JOIN: 'join-session',
  ACTION_CONTINUE_SESSION: 'continue-session',
  ACTION_CONTINUE_IDLING: 'continue-idling',
  ACTION_LEAVE: 'leave-session',
  // This chamber room is already live on another screen; back off and show a takeover prompt.
  ACTION_SCREEN_TAKEN_OVER: 'screen-taken-over',
}

export const UNITS_ARRAY = [
  { id: 'units/L', title: 'units/L' },
  { id: 'g/dL', title: 'g/dL' },
  { id: 'mg/dL', title: 'mg/dL' },
  { id: 'mEq/L', title: 'mEq/L' },
  { id: 'mm Hg', title: 'mm Hg' },
  { id: 'hemoglobin/cell', title: 'hemoglobin/cell' },
  { id: 'µmol/L', title: 'µmol/L' },
  { id: 'mEq/L', title: 'mEq/L' },
]

export const INVESTIGATION_TYPES = {
  test: 'test',
  panel: 'panel',
}

export const INVESTIGATION_TYPES_ARRAY = [
  { id: INVESTIGATION_TYPES.test, title: 'Marker' },
  { id: INVESTIGATION_TYPES.panel, title: 'Panel' },
]

export const INVESTIGATION_TEST_TYPES = {
  audiology: 'audiology',
  imaging: 'imaging',
  microscopy: 'microscopy',
  pathology: 'pathology',
}

export const INVESTIGATION_TEST_TYPES_ARRAY = [
  { id: INVESTIGATION_TEST_TYPES.audiology, title: 'Audiology' },
  { id: INVESTIGATION_TEST_TYPES.imaging, title: 'Imaging' },
  { id: INVESTIGATION_TEST_TYPES.microscopy, title: 'Microscopy' },
  { id: INVESTIGATION_TEST_TYPES.pathology, title: 'Pathology' },
]

export const SAMPLE_TYPE = {
  blood: 'blood',
  urine: 'urine',
  eye: 'eye',
  swab: 'swab',
  imaging: 'imaging',
  saliva: 'saliva',
  electrodesOnScalp: 'electrodes-on-scalp',
  semen: 'semen',
}

export const SAMPLE_TYPE_ARRAY = [
  { id: SAMPLE_TYPE.blood, title: 'Blood' },
  { id: SAMPLE_TYPE.urine, title: 'Urine' },
  { id: SAMPLE_TYPE.eye, title: 'Eye' },
  { id: SAMPLE_TYPE.swab, title: 'Swab' },
  { id: SAMPLE_TYPE.imaging, title: 'Imaging' },
  { id: SAMPLE_TYPE.saliva, title: 'Saliva' },
  { id: SAMPLE_TYPE.electrodesOnScalp, title: 'Electrodes On Scalp' },
  { id: SAMPLE_TYPE.semen, title: 'Semen' },
]

export const DAY_CALENDAR_EACH_SLOT_HEIGHT_PX = 64
export const DAY_CALENDAR_EACH_SLOT_TWO_ROW_HEIGHT_PX = 64

export const SUBTYPE_PRE_CONSULTATION = 'pre-consultation'
export const SUBTYPE_POST_CONSULTATION = 'post-consultation'

export const INVESTIGATION_TYPE_TEST = 'test'
export const INVESTIGATION_TYPE_PANEL = 'panel'

export const STATUS_SESSION_BOOKED = 'booked'
export const STATUS_SESSION_CANCELLED = 'cancelled'
export const STATUS_SESSION_NOT_CREATED = 'booking-not-created'
export const STATUS_SESSION_RESCHEDULED = 'rescheduled'
export const STATUS_SESSION_COMPLETED = 'completed'

export const A4DpiToDetailsMap = {
  96: {
    id: 96,
    title: '96 DPI',
    aspectRatio: 1.41435768262,
    width: 794,
    height: 1123,
  },
  150: {
    id: 150,
    title: '150 DPI',
    aspectRatio: 1.41451612903,
    width: 1240,
    height: 1754,
  },
  300: {
    id: 300,
    title: '300 DPI',
    aspectRatio: 1.41451612903,
    width: 2480,
    height: 3508,
  },
}

export const A4DPIToAspectRatioOptions = [
  A4DpiToDetailsMap?.[96],
  A4DpiToDetailsMap?.[150],
  A4DpiToDetailsMap?.[300],
]

export const REPORT_DATE_TYPES = {
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year',
}

export const REPORT_DATE_TYPES_ARRAY = [
  { id: REPORT_DATE_TYPES.day, title: 'Day' },
  { id: REPORT_DATE_TYPES.week, title: 'Week' },
  { id: REPORT_DATE_TYPES.month, title: 'Month' },
  { id: REPORT_DATE_TYPES.year, title: 'Year' },
]
export const MOMENT_FORMATS = {
  completeTimeDetailsWithMonthShortForm: 'D MMM, YYYY h:mm a',
  completeDateDetailsWithMonthShortFormAndDay: 'ddd, DD MMM, YYYY',
  completeDateDetailsWithMonthShortForm: 'DD MMM, YYYY',
  formatThatServerSends: 'YYYY-MM-DD HH:mm:ss',
  javaLocalDateFormat: 'YYYY-MM-DD',
  completeTimeDetails: 'DD MMMM YYYY h:mm A',
  completeTimeDetailsWithTimeZone: 'DD/MM/YYYY h:mm A (Z)',
  completeTimeDetailsWithTimeZoneName: 'DD/MM/YYYY h:mm A z',
  completeDateDetailsWithTimeZone: 'DD/MM/YYYY (Z)',
  javaInstantFormat: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  javaInstantFormatNew: 'YYYY-MM-DDTHH:mm:ss[Z]',
  formattedTime24Hrs: 'h:mm a',
  javaLocalDateFormatNew: 'YYYY-MM-DD',
}
export const REDUX_STATUS_IDLE = 'idle'
export const REDUX_STATUS_LOADING = 'loading'
export const REDUX_STATUS_SUCCESS = 'success'
export const REDUX_STATUS_FAILED = 'failed'

export const PATIENTS_IMPORT_FORMATS = {
  docon: 'docon',
}

export const PATIENTS_IMPORT_FORMATS_ARRAY = [{ id: PATIENTS_IMPORT_FORMATS.docon, title: 'Docon' }]

export const IDB_STORES = {
  HEALTH_COMPLAINTS: {
    name: 'health_complaints',
    keyPath: 'id',
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  DIAGNOSIS: {
    name: 'diagnosis',
    keyPath: 'id',
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  DRUGS: {
    name: 'drugs',
    keyPath: 'id',
    plaintext: true,
    indexes: [
      { name: 'titleIDX', field: 'lowerCaseIndexField', unique: false },
      // same-formula brand lookups (related drugs) — an index read instead of a
      // full-store scan every time a drug is picked in the Rx table
      { name: 'relatedNameIDX', field: 'relatedName', unique: false },
    ],
  },
  INSTRUCTIONS: {
    name: 'instructions',
    keyPath: 'id',
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  INVESTIGATION: {
    name: 'investigation',
    keyPath: 'id',
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  PSYCH_ASSESSMENTS: {
    name: 'psych_assessments',
    keyPath: 'id',
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  GENERIC_DRUGS: {
    name: 'generic_drugs',
    keyPath: 'id',
    plaintext: true,
    indexes: [
      { name: 'titleIDX', field: 'lowerCaseIndexField', unique: false },
      { name: 'medKeyIDX', field: 'medKey', unique: false },
    ],
  },
  OBSERVATIONS: {
    name: 'observations',
    keyPath: 'id',
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  ADVICE: {
    name: 'advice',
    keyPath: 'id',
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  PATIENTS: {
    name: 'patients',
    keyPath: 'id',
    indexes: [
      { name: 'nameIDX', field: 'nameIDX', unique: false },
      { name: 'mobileIDX', field: 'mobileIDX', unique: false },
      { name: 'emailIDX', field: 'emailIDX', unique: false },
      { name: 'patientNumberIDX', field: 'patientNumberIDX', unique: false },
    ],
  },
  DRUG_ADVICE_DOSAGE: {
    name: 'drug_advice_dosage',
    keyPath: 'id',
    plaintext: true,
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  DRUG_ADVICE_DURATION: {
    name: 'drug_advice_duration',
    keyPath: 'id',
    plaintext: true,
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  DRUG_ADVICE_FREQUENCY: {
    name: 'drug_advice_frequency',
    keyPath: 'id',
    plaintext: true,
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  DRUG_ADVICE_TIMING: {
    name: 'drug_advice_timing',
    keyPath: 'id',
    plaintext: true,
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  DRUG_ADVICE_TYPE: {
    name: 'drug_advice_type',
    keyPath: 'id',
    plaintext: true,
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  DRUG_ADVICE_NOTE: {
    name: 'drug_advice_note',
    keyPath: 'id',
    plaintext: true,
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  // per-doctor prescription intelligence snapshots (frequent + context-linked
  // suggestions) — small, keyed reads only, so it stays encrypted at rest
  PRESCRIPTION_INTEL: {
    name: 'prescription_intel',
    keyPath: 'id',
    indexes: [],
  },
  // ICD-10-aware clinical vocabulary (WHO catalog + clinic-curated entries)
  CLINICAL_DIAGNOSIS: {
    name: 'clinical_diagnosis',
    keyPath: 'id',
    plaintext: true,
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  CLINICAL_SYMPTOMS: {
    name: 'clinical_symptoms',
    keyPath: 'id',
    plaintext: true,
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
  CLINICAL_DESCRIPTORS: {
    name: 'clinical_descriptors',
    keyPath: 'id',
    plaintext: true,
    indexes: [{ name: 'titleIDX', field: 'lowerCaseIndexField', unique: false }],
  },
}

export const LOCALSTORAGE_KEYS_IDB_STORE_LAST_UPDATED = {
  DRUGS: 'drugsLastUpdatedInIdb',
  COMPLAINTS: 'complaintsLastUpdatedInIdb',
  DIAGNOSIS: 'diagnosisLastUpdatedInIdb',
  OBSERVATIONS: 'observationsLastUpdatedInIdb',
  ADVICES: 'advicesLastUpdatedInIdb',
  INSTRUCTIONS: 'instructionsLastUpdatedInIdb',
  INVESTIGATION: 'investigationLastUpdatedInIdb',
  PATIENTS: 'patientsLastUpdatedInIdb',
  PSYCH_ASSESSMENTS: 'psychAssessmentsLastUpdatedInIdb',
  GENERIC_DRUGS: 'genericDrugsLastUpdatedInIdb',
  DRUG_ADVICE_ENTITIES: 'drugAdviceEntitiesLastUpdatedInIdb',
  CLINICAL_DIAGNOSIS: 'clinicalDiagnosisLastUpdatedInIdb',
  CLINICAL_SYMPTOMS: 'clinicalSymptomsLastUpdatedInIdb',
  CLINICAL_DESCRIPTORS: 'clinicalDescriptorsLastUpdatedInIdb',
}

export const HE_KEY_HEALTH_COMPLAINTS = 'health-complaint'
export const HE_KEY_DIAGNOSIS = 'diagnosis'
export const HE_KEY_DRUGS = 'drug-info'
export const HE_KEY_INSTRUCTIONS = 'instruction'
export const HE_KEY_INVESTIGATION = 'investigation'
export const HE_KEY_OBSERVATIONS = 'health-observation'
export const HE_KEY_PSYCH_ASSESSMENTS = 'psych-assessment'
export const HE_KEY_ADVICE = 'prescription-advice'
export const HE_DRUG_ADVICE_NOTE = 'drug-advice-note'
export const HE_DRUG_ADVICE_TIMING = 'drug-advice-timing'
export const HE_DRUG_ADVICE_TYPE = 'drug-info-type'
export const HE_DRUG_ADVICE_DURATION = 'drug-advice-duration'
export const HE_DRUG_ADVICE_DOSAGE = 'drug-advice-dosage'
export const HE_DRUG_ADVICE_FREQUENCY = 'drug-advice-frequency'
export const HE_DRUG_GENERIC_FORMULA = 'drug-generic-formula'

export const HE_TO_IDB_KEYS_MAP = {
  [HE_KEY_HEALTH_COMPLAINTS]: IDB_STORES.HEALTH_COMPLAINTS.name,
  [HE_KEY_DIAGNOSIS]: IDB_STORES.DIAGNOSIS.name,
  [HE_KEY_DRUGS]: IDB_STORES.DRUGS.name,
  [HE_KEY_INSTRUCTIONS]: IDB_STORES.INSTRUCTIONS.name,
  [HE_KEY_INVESTIGATION]: IDB_STORES.INVESTIGATION.name,
  [HE_KEY_OBSERVATIONS]: IDB_STORES.OBSERVATIONS.name,
  [HE_KEY_ADVICE]: IDB_STORES.ADVICE.name,
}

export const JOINT_HOMUNCULUS_DATA = {
  // Acromioclavicular Joint
  acromioclavicularright: false, // Acromioclavicular right
  acromioclavicularleft: false, // Acromioclavicular left

  // Sternoclavicular Joint
  sternoclavicularright: false, // Sternoclavicular right
  sternoclavicularleft: false, // Sternoclavicular left

  // Shoulder Joint
  shoulderright: false, // Shoulder right
  shoulderleft: false, // Shoulder left

  // Elbow Joint
  elbowright: false, // Elbow right
  elbowleft: false, // Elbow left

  // Wrist Joint
  wristright: false, // Wrist right
  wristleft: false, // Wrist left

  // Finger Joints (PIP and MCP)
  pip5right: false, // PIP (Proximal Interphalangeal) right, 5th finger
  pip5left: false, // PIP left, 5th finger
  pip4right: false, // PIP right, 4th finger
  pip4left: false, // PIP left, 4th finger
  pip3right: false, // PIP right, 3rd finger
  pip3left: false, // PIP left, 3rd finger
  pip2right: false, // PIP right, 2nd finger
  pip2left: false, // PIP left, 2nd finger
  pip1right: false, // PIP right, 1st finger
  pip1left: false, // PIP left, 1st finger

  mcp5right: false, // MCP (Metacarpophalangeal) right, 5th finger
  mcp5left: false, // MCP left, 5th finger
  mcp4right: false, // MCP right, 4th finger
  mcp4left: false, // MCP left, 4th finger
  mcp3right: false, // MCP right, 3rd finger
  mcp3left: false, // MCP left, 3rd finger
  mcp2right: false, // MCP right, 2nd finger
  mcp2left: false, // MCP left, 2nd finger
  mcp1right: false, // MCP right, 1st finger
  mcp1left: false, // MCP left, 1st finger

  // Knee Joint
  kneeright: false, // Knee right
  kneeleft: false, // Knee left

  // Ankle Joint
  ankleright: false, // Ankle right
  ankleleft: false, // Ankle left

  // MTP Joints (Metatarsophalangeal)
  mtp5right: false, // MTP right, 5th toe
  mtp5left: false, // MTP left, 5th toe
  mtp4right: false, // MTP right, 4th toe
  mtp4left: false, // MTP left, 4th toe
  mtp3right: false, // MTP right, 3rd toe
  mtp3left: false, // MTP left, 3rd toe
  mtp2right: false, // MTP right, 2nd toe
  mtp2left: false, // MTP left, 2nd toe
  mtp1right: false, // MTP right, 1st toe
  mtp1left: false, // MTP left, 1st toe
}

export const PRESCRIPTION_BUILDER_VIEW_TYPES = {
  minimal: 'minimal',
  modern: 'modern',
  tabletView: 'tabletView',
}

export const PRESCRIPTION_BUILDER_VIEW_TYPES_ARRAY = [
  { id: PRESCRIPTION_BUILDER_VIEW_TYPES.minimal, title: 'Minimal' },
  { id: PRESCRIPTION_BUILDER_VIEW_TYPES.modern, title: 'Modern' },
  { id: PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView, title: 'Tablet View' },
]

export const STORAGE_KEYS = {
  restApiURL: 'apiURL',
  restCustomApiURL: 'customApiURL',
  publicApiURL: 'publicApiURL',
  publicCustomApiURL: 'customPublicApiURL',
}

export const HEADER_TYPES = {
  onAllPages: 'onAllPages',
  onAlternatePages: 'onAlternatePages',
  onFirstPage: 'onFirstPage',
  blankHeader: 'blankHeader',
}

export const HEADER_TYPES_ARRAY = [
  {
    id: HEADER_TYPES.onAllPages,
    title: 'On All Pages',
    description: 'Shows the header at the top of every generated prescription page.',
    example: 'Example: a three page prescription prints the same header on pages 1, 2, and 3.',
    imageSupportText: 'Works with uploaded header images and built-in text headers.',
  },
  {
    id: HEADER_TYPES.onFirstPage,
    title: 'On First Page',
    description: 'Shows the header only on the first generated prescription page.',
    example:
      'Example: page 1 carries the full letterhead, while pages 2 and 3 start directly with prescription content.',
    imageSupportText: 'Works with uploaded header images and built-in text headers.',
  },
  {
    id: HEADER_TYPES.onAlternatePages,
    title: 'On Alternate Pages',
    description: 'Shows the header on alternating pages, starting from page 1.',
    example: 'Example: a five page prescription prints the header on pages 1, 3, and 5.',
    imageSupportText: 'Works with uploaded header images and built-in text headers.',
  },
]

export const FOOTER_TYPES = {
  onAllPages: 'onAllPages',
  onAlternatePages: 'onAlternatePages',
  onLastPage: 'onLastPage',
  inLineAtEnd: 'inLineAtEnd',
  // blankFooter: 'blankFooter',
}

export const FOOTER_TYPES_ARRAY = [
  {
    id: FOOTER_TYPES.onAllPages,
    title: 'On All Pages',
    description: 'Shows the footer at the bottom of every generated prescription page.',
    example: 'Example: a three page prescription prints the same footer on pages 1, 2, and 3.',
    imageSupportText: 'Works with uploaded footer images and built-in footer layouts.',
  },
  {
    id: FOOTER_TYPES.onLastPage,
    title: 'On Last Page',
    description: 'Shows the footer only on the final generated prescription page.',
    example: 'Example: pages 1 and 2 have no footer, and page 3 carries the footer at the end.',
    imageSupportText: 'Works with uploaded footer images and built-in footer layouts.',
  },
  {
    id: FOOTER_TYPES.onAlternatePages,
    title: 'On Alternate Pages',
    description: 'Shows the footer on alternating pages, starting from page 1.',
    example: 'Example: a five page prescription prints the footer on pages 1, 3, and 5.',
    imageSupportText: 'Works with uploaded footer images and built-in footer layouts.',
  },
  {
    id: FOOTER_TYPES.inLineAtEnd,
    title: 'Inline at the end',
    description:
      'Places the footer after the final prescription content instead of reserving a footer slot on every page.',
    example:
      'Example: if the content ends midway through the last page, the footer appears immediately after that content.',
    imageSupportText:
      'Works with uploaded footer images and built-in footer layouts, positioned after the final content.',
  },
]

export const BODY_TYPES = {
  singleColumn: 'singleColumn',
  twoColumn: 'twoColumn',
}

export const BODY_FIT_TYPES_ARRAY = [
  { id: BODY_TYPES.singleColumn, title: 'Single Column' },
  { id: BODY_TYPES.twoColumn, title: 'Two Column' },
]

// Vitals section display formats.
export const VITALS_DISPLAY_FORMATS = {
  list: 'list',
  bullet: 'bullet',
  table: 'table',
}

export const VITALS_DISPLAY_FORMAT_OPTIONS = [
  { id: VITALS_DISPLAY_FORMATS.list, title: 'List', description: 'Key-value pairs separated inline.' },
  { id: VITALS_DISPLAY_FORMATS.bullet, title: 'Bullet points', description: 'Each vital on its own bullet line.' },
  { id: VITALS_DISPLAY_FORMATS.table, title: 'Table', description: 'Vital / Observation / Biological Reference Interval columns.' },
]

// Prescription-wide separator for list-style key/value rendering. Default comma.
export const LIST_ITEM_SEPARATORS = {
  comma: ', ',
  pipe: ' | ',
  semicolon: '; ',
}

export const LIST_ITEM_SEPARATOR_OPTIONS = [
  { id: LIST_ITEM_SEPARATORS.comma, title: 'Comma  ( , )' },
  { id: LIST_ITEM_SEPARATORS.pipe, title: 'Pipe  ( | )' },
  { id: LIST_ITEM_SEPARATORS.semicolon, title: 'Semicolon  ( ; )' },
]

export const DEFAULT_LIST_ITEM_SEPARATOR = LIST_ITEM_SEPARATORS.comma

// The footer has THREE mutually-exclusive modes, selected via footer.footerMode:
//   - auto:   built-in field toggles (the "auto-created" footer / PrintFooterMetaBar)
//   - custom: hand-authored headline/subtext/support-text fields (DefaultPrescriptionFooter)
//   - image:  an uploaded footer image
export const FOOTER_MODES = {
  auto: 'auto',
  custom: 'custom',
  image: 'image',
}

export const FOOTER_MODE_OPTIONS = [
  {
    id: FOOTER_MODES.auto,
    title: 'Auto-created footer',
    description: 'Built from the footer fields below (name, page number, logo, QR, etc.).',
  },
  {
    id: FOOTER_MODES.custom,
    title: 'Create your own footer',
    description: 'Use custom headline / subtext / support-text fields.',
  },
  {
    id: FOOTER_MODES.image,
    title: 'Image footer',
    description: 'Upload a footer image.',
  },
]

// Print-footer field toggles for the "auto-created" footer mode. Each toggle is opt-in
// (default false) so existing live templates keep their current printed footer until a
// practitioner explicitly enables an option.
export const PRINT_FOOTER_FIELD_IDS = {
  showName: 'showName',
  showRegistrationNumber: 'showRegistrationNumber',
  showNotValidForMedicalPurpose: 'showNotValidForMedicalPurpose',
  showPageNumber: 'showPageNumber',
  showPrescriptionId: 'showPrescriptionId',
  showAumhumLogo: 'showAumhumLogo',
  showApprovalDetails: 'showApprovalDetails',
  showQr: 'showQr',
}

export const PRINT_FOOTER_FIELD_OPTIONS = [
  {
    id: PRINT_FOOTER_FIELD_IDS.showName,
    label: 'Show practitioner name',
    help: "Prints the practitioner's name (bold) at the bottom-right of the footer instead of the signature panel. When on, the separate signature block is hidden (the name sits in the footer, like Eka Care).",
  },
  {
    id: PRINT_FOOTER_FIELD_IDS.showRegistrationNumber,
    label: 'Show registration number',
    help: 'Prints the registration number just below the practitioner name. Enter the number in the field that appears.',
  },
  {
    id: PRINT_FOOTER_FIELD_IDS.showNotValidForMedicalPurpose,
    label: 'Show "Not valid for medical purpose" note',
    help: 'Adds a small disclaimer line stating this prescription is not valid for medical/legal purposes.',
  },
  {
    id: PRINT_FOOTER_FIELD_IDS.showPageNumber,
    label: 'Show page number',
    help: 'Prints "Page X of Y" in the footer. When on, the "Continued"/"Continuing" continuation boxes are not shown.',
  },
  {
    id: PRINT_FOOTER_FIELD_IDS.showPrescriptionId,
    label: 'Show prescription ID',
    help: 'Prints the prescription reference ID in the footer.',
  },
  {
    id: PRINT_FOOTER_FIELD_IDS.showAumhumLogo,
    label: 'Show AUMHUM logo',
    help: 'Prints the AUMHUM logo in the footer.',
  },
  {
    id: PRINT_FOOTER_FIELD_IDS.showApprovalDetails,
    label: 'Show approval details',
    help: 'Prints an authorization line, e.g. "Prescription authorized by Dr. Naveen Kumar on <date>".',
  },
  {
    id: PRINT_FOOTER_FIELD_IDS.showQr,
    label: 'Show QR code',
    help: 'Prints the prescription QR code in the footer (when a QR is available).',
  },
]

// All opt-in by default. The footer SOURCE (image vs built-in fields) is "preselected"
// via auto behaviour; these per-field toggles start off so nothing changes for existing
// templates until enabled.
export const DEFAULT_PRINT_FOOTER_SETTINGS = {
  showName: false,
  showRegistrationNumber: false,
  showNotValidForMedicalPurpose: false,
  showPageNumber: false,
  showPrescriptionId: false,
  showAumhumLogo: false,
  showApprovalDetails: false,
  showQr: false,
  // Free-text value printed under the name when showRegistrationNumber is on.
  registrationNumber: '',
}

/**
 * Derive the footer mode for a template footer that predates the explicit footerMode
 * field. image (has imageId) → custom-fields (has any headline/subtext/etc) is preserved
 * as 'custom' so existing printed footers don't change; templates that already enabled
 * auto-footer toggles resolve to 'auto'. Everything else defaults to 'auto' (the modern
 * footer) for a clean starting point.
 */
export const deriveFooterMode = (footer) => {
  if (!footer) return FOOTER_MODES.auto
  if (footer.footerMode) return footer.footerMode
  if (footer.imageId) return FOOTER_MODES.image
  const pfs = footer.printFooterSettings
  if (pfs && Object.keys(pfs).some((k) => k !== 'registrationNumber' && pfs[k])) {
    return FOOTER_MODES.auto
  }
  const hasCustom =
    footer.headline ||
    footer.subtext ||
    footer.supportText ||
    footer.headlineAlt ||
    footer.subtextAlt ||
    footer.supportTextAlt ||
    footer.disclaimerText ||
    (Array.isArray(footer.footerListItems) && footer.footerListItems.length > 0)
  return hasCustom ? FOOTER_MODES.custom : FOOTER_MODES.auto
}
// ROLE_CA_FLOWS removed: each portal (CA / Kiosk / Display) now has a single
// pre-defined flow, so the selectable flow field is no longer needed. The flow
// is implied by the portal; the few backend-protocol calls that still send a
// flow string inline the fixed per-portal value ('reception-tablet',
// 'remote-doctor', 'appointment-screen').

export const SCREEN_DEVICE_CONFIG_INSTALLATION_TYPES = {
  PHARMACY: 'pharmacy',
  CLINIC: 'clinic',
}

export const MENTOR_ONBOARDING_TYPES = {
  DOCTOR: 'doctor',
  THERAPIST: 'therapist',
}

export const MENTOR_REG_ID_TYPES = {
  rci: {
    id: 'rci',
    title: 'RCI',
    specializations: ['therapist', 'clinical-psychologist'],
  },
  cmo: {
    id: 'cmo',
    title: 'CMO ID',
    specializations: ['doctor'],
  },
  mci: {
    id: 'mci',
    title: 'MCI Registeration ID',
    specializations: ['doctor'],
  },
}

export const MENTOR_REG_ID_TYPE_ARRAY = [
  MENTOR_REG_ID_TYPES.rci,
  MENTOR_REG_ID_TYPES.cmo,
  MENTOR_REG_ID_TYPES.mci,
]

// export const MENTOR_PROFILE_

export const PAY_IN_FUTURE_ALLOWED_MENTOR_IDS = [
  'TCH-1e6ef72d2ce145f1943e4bda35940bf5',
  'TCH-ddb757179d174739a46133ac7db0c4f8',
]

export const DISPATCH_EVENT_KEYS = {
  appUpdateActionEvent: 'app-update-action',
  signalingEvent: 'signaling-event',
  aumhumScreenSignalingEvent: 'aumhum-screen-signaling-event',
  userCheckedIn: 'user-checked-in',
  userRefreshCheckedIn: 'user-refresh-check-in',
  userCheckedOut: 'user-checked-out',
  tryingToUpdateApp: 'trying-to-update-app',
  mentorSignalingEvent: 'mentor-signaling-event',
  supportSignalingEvent: 'support-signaling-event',
  // userPeekedIn: 'user-peeked-in',
}

export const APP_UPDATE_ACTIONS = {
  SUGGEST_UPDATE: 'suggest-update',
  FORCE_UPDATE: 'force-update',
}

export const paymentMethodKeyValueMap = {
  BOOKING_FEE_PAYMENT_METHOD_CASH: 'cash',
  BOOKING_FEE_PAYMENT_METHOD_CARD: 'debit_and_credit_cards',
  BOOKING_FEE_PAYMENT_METHOD_PHONEPE: 'phonepe',
  BOOKING_FEE_PAYMENT_METHOD_GPAY: 'google_pay',
  BOOKING_FEE_PAYMENT_METHOD_PAYTM: 'paytm',
  BOOKING_FEE_PAYMENT_METHOD_OTHER_UPI: 'other_upi',
  BOOKING_FEE_PAYMENT_METHOD_COLLECTED_BY_AUMHUM: 'aumhum',
}

export const paymentMethodTitleMap = {
  cash: 'Cash',
  debit_and_credit_cards: 'Debit and Credit Cards',
  phonepe: 'PhonePe',
  google_pay: 'Google Pay',
  paytm: 'Paytm',
  other_upi: 'Other UPI',
  aumhum: 'Collected by AUMHUM',
}

export const VISIT_EVENT_TYPES = {
  regular: 'regular',
  followUp: 'follow-up',
  emergency: 'emergency',
}

export const SIREN_ICON_ID = 'MEDIA-661e7309c6884802a74a4a9e6bb93f06'

export const VISIT_EVENT_TYPES_ARRAY = [
  { id: VISIT_EVENT_TYPES.regular, title: 'Regular' },
  { id: VISIT_EVENT_TYPES.followUp, title: 'Follow-Up', Icon: CalendarMonthIcon },
  {
    id: VISIT_EVENT_TYPES.emergency,
    title: 'Emergency',
    iconImageId: SIREN_ICON_ID,
  },
]

export const PRINT_PAGE_TYPES = {
  a4: 'a4',
  a5: 'a5',
  a6: 'a6',
}

export const PRINT_PAGE_ARRAY = [
  { id: PRINT_PAGE_TYPES.a4, title: 'A4' },
  { id: PRINT_PAGE_TYPES.a5, title: 'A5' },
  {
    id: PRINT_PAGE_TYPES.a6,
    title: 'A6',
  },
]

export const DEFAULT_PRINT_SETTINGS = {
  printType: 'print',
  printHeaderType: HEADER_TYPES.onAllPages,
  pdfHeaderType: HEADER_TYPES.onAllPages,
  selectedPrescriptionTemplate: {},
  useOldPrintMethod: false,
  headerHeight: 2,
  pdfHeaderHeight: 200,
  dpi: 96,
}

export const PAYMENT_METHOD_KV_MAP = {
  BOOKING_FEE_PAYMENT_METHOD_CASH: 'cash',
  BOOKING_FEE_PAYMENT_METHOD_CARD: 'debit_and_credit_cards',
  BOOKING_FEE_PAYMENT_METHOD_PHONEPE: 'phonepe',
  BOOKING_FEE_PAYMENT_METHOD_GPAY: 'google_pay',
  BOOKING_FEE_PAYMENT_METHOD_PAYTM: 'paytm',
  BOOKING_FEE_PAYMENT_METHOD_OTHER_UPI: 'other_upi',
  BOOKING_FEE_PAYMENT_METHOD_COLLECTED_BY_AUMHUM: 'aumhum',
}

export const PAYMENT_METHOD_TITLE_MAP = {
  cash: 'Cash',
  debit_and_credit_cards: 'Debit and Credit Cards',
  phonepe: 'PhonePe',
  google_pay: 'Google Pay',
  paytm: 'Paytm',
  other_upi: 'Other UPI',
  aumhum: 'Collected by AUMHUM',
}

export const PAYMENT_METHODS_ARRAY = [
  {
    id: PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_CASH,
    title: PAYMENT_METHOD_TITLE_MAP[PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_CASH],
  },
  {
    id: PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_CARD,
    title: PAYMENT_METHOD_TITLE_MAP[PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_CARD],
  },
  {
    id: PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_PHONEPE,
    title: PAYMENT_METHOD_TITLE_MAP[PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_PHONEPE],
  },
  {
    id: PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_GPAY,
    title: PAYMENT_METHOD_TITLE_MAP[PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_GPAY],
  },
  {
    id: PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_PAYTM,
    title: PAYMENT_METHOD_TITLE_MAP[PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_PAYTM],
  },
  {
    id: PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_OTHER_UPI,
    title: PAYMENT_METHOD_TITLE_MAP[PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_OTHER_UPI],
  },
  {
    id: PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_COLLECTED_BY_AUMHUM,
    title:
      PAYMENT_METHOD_TITLE_MAP[
        PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_COLLECTED_BY_AUMHUM
      ],
  },
]

export const APPLICABLE_TO_ENTITY = {
  clinic: { id: 'clinic', title: 'Clinic' },
  mentor: { id: 'mentor', title: 'Mentor' },
}

export const EVENT_TYPE_ONE_ON_ONE = '1on1'
export const EVENT_TYPE_INTERVIEW = 'interview'
export const EVENT_TYPE_SCREENING = 'screening'
export const EVENT_TYPE_CONSULTATION = 'consultation'
export const EVENT_TYPE_THERAPY_SESSION = 'therapy-session'
export const EVENT_TYPE_NUTRITION_CONSULTATION = 'nutrition-consultation'
export const EVENT_TYPE_WEBINAR = 'webinar'
export const EVENT_TYPE_ASSESSMENT = 'assessment'

export const EVENT_SUBTYPE_INDIVIDUAL_THERAPY = 'individual-therapy'
export const EVENT_SUBTYPE_COUPLE_THERAPY = 'couple-therapy'
export const EVENT_SUBTYPE_THERAPIST_ASSESSMENT = 'therapist-assessment'

// Therapy disciplines — orthogonal to event subtype (which is session-format). Defaults to
// psychotherapy when absent. Nutrition consultation is a non-psych therapy flavour that uses the
// same therapy-report pipeline with a different EMR section set.
export const THERAPY_DISCIPLINE_PSYCHOTHERAPY = 'psychotherapy'
export const THERAPY_DISCIPLINE_NUTRITION_CONSULTATION = 'nutrition-consultation'

// All known therapy disciplines, in display order. The Create Event drawer filters this list
// against the mentor's KYC-approved set (teacherUnEditableFields.approvedTherapyDisciplines)
// before rendering the picker. Adding a new discipline backend-side requires a corresponding
// entry here for the UI to label it; otherwise the code falls back to the raw discipline value.
export const THERAPY_DISCIPLINE_OPTIONS = [
  { code: THERAPY_DISCIPLINE_PSYCHOTHERAPY, label: 'Psychotherapy' },
  { code: THERAPY_DISCIPLINE_NUTRITION_CONSULTATION, label: 'Nutrition Consultation' },
]

export function therapyDisciplineLabel(code) {
  if (!code) return THERAPY_DISCIPLINE_OPTIONS[0].label
  return THERAPY_DISCIPLINE_OPTIONS.find((opt) => opt.code === code)?.label ?? code
}

export const THERAPY_DISCIPLINE_PRACTITIONER_NOUNS = {
  [THERAPY_DISCIPLINE_PSYCHOTHERAPY]: 'Therapist',
  [THERAPY_DISCIPLINE_NUTRITION_CONSULTATION]: 'Nutritionist',
}

export function inferTherapyDisciplineFromText(value) {
  if (!value) return null
  const normalized = String(value).toLowerCase()
  if (
    normalized === THERAPY_DISCIPLINE_NUTRITION_CONSULTATION ||
    normalized.includes('nutrition consultation') ||
    normalized.includes('nutrition-consultation')
  ) {
    return THERAPY_DISCIPLINE_NUTRITION_CONSULTATION
  }
  if (
    normalized === THERAPY_DISCIPLINE_PSYCHOTHERAPY ||
    normalized.includes('psychotherapy')
  ) {
    return THERAPY_DISCIPLINE_PSYCHOTHERAPY
  }
  return null
}

function getTherapyDisciplineIfAvailable(bookedEventOrEventType) {
  if (!bookedEventOrEventType) return null
  if (typeof bookedEventOrEventType === 'string') {
    if (bookedEventOrEventType === EVENT_TYPE_NUTRITION_CONSULTATION) {
      return THERAPY_DISCIPLINE_NUTRITION_CONSULTATION
    }
    return inferTherapyDisciplineFromText(bookedEventOrEventType)
  }
  const eventType = bookedEventOrEventType.eventType ?? bookedEventOrEventType.type
  const isTherapyReportEvent =
    !eventType ||
    eventType === EVENT_TYPE_THERAPY_SESSION ||
    eventType === EVENT_TYPE_NUTRITION_CONSULTATION
  if (!isTherapyReportEvent) {
    return null
  }
  const explicit =
    bookedEventOrEventType.discipline ??
    bookedEventOrEventType.therapyDiscipline ??
    bookedEventOrEventType.therapyDisciplineCode
  if (explicit) return explicit
  if (eventType === EVENT_TYPE_NUTRITION_CONSULTATION) {
    return THERAPY_DISCIPLINE_NUTRITION_CONSULTATION
  }
  return (
    inferTherapyDisciplineFromText(bookedEventOrEventType.title) ||
    inferTherapyDisciplineFromText(bookedEventOrEventType.name) ||
    inferTherapyDisciplineFromText(bookedEventOrEventType.displayName)
  )
}

export function resolveTherapyDiscipline(bookedEventOrEventType) {
  if (!bookedEventOrEventType) return THERAPY_DISCIPLINE_PSYCHOTHERAPY
  // Phase 14ba — `therapyDiscipline` was renamed to `discipline` on EventType +
  // BookedEvent so the field can be reused for non-therapy events (consultations,
  // assessments, screenings) once support starts populating it. The bidirectional
  // setter on the backend bean keeps both fields in sync at write time, so reading
  // either is safe — but we prefer the new field in case a future write path forgets
  // to mirror, and fall back to the old name for inflight payloads + legacy snapshots.
  return (
    getTherapyDisciplineIfAvailable(bookedEventOrEventType) ||
    THERAPY_DISCIPLINE_PSYCHOTHERAPY
  )
}

export function getSessionDisciplineLabelIfAvailable(bookedEventOrEventType) {
  const discipline = getTherapyDisciplineIfAvailable(bookedEventOrEventType)
  return discipline ? therapyDisciplineLabel(discipline) : null
}

export function getSessionDisplayLabel(bookedEventOrEventType) {
  const disciplineLabel = getSessionDisciplineLabelIfAvailable(bookedEventOrEventType)
  if (disciplineLabel) return disciplineLabel
  const eventType =
    typeof bookedEventOrEventType === 'string'
      ? bookedEventOrEventType
      : bookedEventOrEventType?.eventType ?? bookedEventOrEventType?.type
  return displayNamesOfEventTypes?.[eventType] || eventType || 'Session'
}

export function practitionerNounForTherapyDiscipline(discipline) {
  return THERAPY_DISCIPLINE_PRACTITIONER_NOUNS[discipline] || 'Practitioner'
}

export function practitionerNounForSession(bookedEventOrEventType) {
  const eventType =
    typeof bookedEventOrEventType === 'string'
      ? bookedEventOrEventType
      : bookedEventOrEventType?.eventType ?? bookedEventOrEventType?.type
  if (
    eventType === EVENT_TYPE_THERAPY_SESSION ||
    eventType === EVENT_TYPE_NUTRITION_CONSULTATION ||
    getSessionDisciplineLabelIfAvailable(bookedEventOrEventType)
  ) {
    return practitionerNounForTherapyDiscipline(resolveTherapyDiscipline(bookedEventOrEventType))
  }
  if (eventType === EVENT_TYPE_CONSULTATION) {
    return 'Doctor'
  }
  return 'Practitioner'
}

export const EVENT_TYPES_ARRAY = [
  {
    id: EVENT_TYPE_ONE_ON_ONE,
    title: 'One on One',
    mentorNoun: 'Therapist',
    subtypes: [
      {
        id: EVENT_SUBTYPE_INDIVIDUAL_THERAPY,
        title: 'Individual Therapy',
      },
    ],
  },
  {
    id: EVENT_TYPE_INTERVIEW,
    title: 'Interview',
    mentorNoun: 'Interviewer',
    subtypes: [],
  },
  {
    id: EVENT_TYPE_SCREENING,
    title: 'Screening',
    altTitle: 'Screening',
    mentorNoun: 'Screener',
    subtypes: [],
  },
  {
    id: EVENT_TYPE_CONSULTATION,
    title: 'Consultation',
    altTitle: 'Consultation',
    mentorNoun: 'Doctor',
    subtypes: [],
  },
  {
    id: EVENT_TYPE_THERAPY_SESSION,
    title: 'Therapy Session',
    altTitle: 'Therapy',
    mentorNoun: 'Therapist',
    subtypes: [
      {
        id: EVENT_SUBTYPE_INDIVIDUAL_THERAPY,
        title: 'Individual Therapy',
      },
      {
        id: EVENT_SUBTYPE_COUPLE_THERAPY,
        title: 'Couple Therapy',
      },
    ],
  },
  {
    id: EVENT_TYPE_WEBINAR,
    title: 'Webinar',
    mentorNoun: 'Mentor',
    subtypes: [],
  },
]

export function getEventTypeObject(eventTypeId) {
  return EVENT_TYPES_ARRAY.find((eventType) => eventType.id === eventTypeId)
}

export const EVENT_MODES = {
  online: { id: 'online', title: 'Online', altTitle: 'Online' },
  offline: { id: 'offline', title: 'Offline', altTitle: 'In Person' },
}

export const EVENT_MODES_ARRAY = [EVENT_MODES.online, EVENT_MODES.offline]

export const BOOKED_EVENT_MODES_TYPES = {
  online: 'aumhum',
  offline: 'offline',
}

export const BOOKED_EVENT_MODES = {
  aumhum: {
    id: BOOKED_EVENT_MODES_TYPES.online,
    altId: 'online',
    title: 'Online',
    altTitle: 'Online',
  },
  offline: {
    id: BOOKED_EVENT_MODES_TYPES.offline,
    altId: 'offline',
    title: 'Offline',
    altTitle: 'In Person',
  },
}

export const BOOKED_EVENT_MODES_ARRAY = [BOOKED_EVENT_MODES.aumhum, BOOKED_EVENT_MODES.offline]

export const EVENT_TYPE_MENTOR_NOUN = {
  EVENT_TYPE_CONSULTATION: 'Doctor',
  EVENT_TYPE_THERAPY_SESSION: 'Therapist',
}

export const ENTITY_FEE_MODEL_APPLICABLE_TO_VALUES = {
  'clinic-doctors': {
    id: 'clinic-doctors',
    title: 'Clinic Doctors',
    titleForEntityModel: 'Doctors on Clinic Rolls',
    for: APPLICABLE_TO_ENTITY.clinic.id,
  },
  'clinic-therapists': {
    id: 'clinic-therapists',
    title: 'Clinic Therapists',
    titleForEntityModel: 'Therapists on Clinic Rolls',
    for: APPLICABLE_TO_ENTITY.clinic.id,
  },
  'clinic-screeners': {
    id: 'clinic-screeners',
    title: 'Clinic Screeners',
    titleForEntityModel: 'Screeners on Clinic Rolls',
    for: APPLICABLE_TO_ENTITY.clinic.id,
  },
  'aumhum-network-doctors': {
    id: 'aumhum-network-doctors',
    title: 'AUMHUM Network Doctors',
    titleForEntityModel: 'AUMHUM Provided Doctors',
    for: APPLICABLE_TO_ENTITY.clinic.id,
  },
  'aumhum-network-therapists': {
    id: 'aumhum-network-therapists',
    title: 'AUMHUM Network Therapists',
    titleForEntityModel: 'AUMHUM Provided Therapists',
    for: APPLICABLE_TO_ENTITY.clinic.id,
  },
  'aumhum-network-screeners': {
    id: 'aumhum-network-screeners',
    title: 'AUMHUM Network Screeners',
    titleForEntityModel: 'AUMHUM Provided Screeners',
    for: APPLICABLE_TO_ENTITY.clinic.id,
  },
  'aumhum-network-clinics': {
    id: 'aumhum-network-clinics',
    title: 'AUMHUM Network Clinics',
    for: APPLICABLE_TO_ENTITY.mentor.id,
    longDesc:
      'Patients coming via clinics in different part of the world. These patients belong to the clinic and you are providing the service on behalf of the clinic. Clinic usually collects money here.',
  },
  'private-patients': {
    id: 'private-patients',
    title: 'Private Patients',
    for: APPLICABLE_TO_ENTITY.mentor.id,
    longDesc: 'These are your existing personal patients, from before joining AUMHUM.',
  },
  'aumhum-direct-patients': {
    id: 'aumhum-direct-patients',
    title: 'AUMHUM Direct Patients',
    for: APPLICABLE_TO_ENTITY.mentor.id,
    longDesc:
      'Patients coming directly through different AUMHUM programs and not through clinics. Examples are Potential Bloom Program, AUMHUM de-addiction packages and directly serving customers.',
  },
}

export const ENTITY_FEE_MODEL_APPLICABLE_TO_VALUES_ARRAY = [
  ENTITY_FEE_MODEL_APPLICABLE_TO_VALUES['aumhum-direct-patients'],
  ENTITY_FEE_MODEL_APPLICABLE_TO_VALUES['aumhum-network-clinics'],
  ENTITY_FEE_MODEL_APPLICABLE_TO_VALUES['aumhum-network-doctors'],
  ENTITY_FEE_MODEL_APPLICABLE_TO_VALUES['aumhum-network-screeners'],
  ENTITY_FEE_MODEL_APPLICABLE_TO_VALUES['aumhum-network-therapists'],
  ENTITY_FEE_MODEL_APPLICABLE_TO_VALUES['clinic-doctors'],
  ENTITY_FEE_MODEL_APPLICABLE_TO_VALUES['clinic-screeners'],
  ENTITY_FEE_MODEL_APPLICABLE_TO_VALUES['clinic-therapists'],
  ENTITY_FEE_MODEL_APPLICABLE_TO_VALUES['private-patients'],
]

export const ALL_GENDERS = [
  { id: 'male', title: 'Male' },
  { id: 'female', title: 'Female' },
  { id: 'nonBinary', title: 'Non Binary' },
]

export const CLINIC_APPOINTMENT_TYPES = {
  consultation: { id: 'consultation', title: 'Consultation' },
  'therapy-session': { id: 'therapy-session', title: 'Therapy' },
  'therapy-packages': { id: 'therapy-packages', title: 'Therapy Packages' },
  assessments: { id: 'assessments', title: 'Assessments' },
  other: { id: 'other', title: 'Other' },
}

/** EventType-aligned options for clinic service "Appointment Type" dropdown (matches backend/template type). */
export const CLINIC_EVENT_TYPES_FOR_SERVICES = [
  { id: EVENT_TYPE_CONSULTATION, title: 'Consultation' },
  { id: EVENT_TYPE_THERAPY_SESSION, title: 'Therapy Session' },
  { id: EVENT_TYPE_SCREENING, title: 'Screening' },
  { id: EVENT_TYPE_ASSESSMENT, title: 'Assessment' },
  { id: 'therapy-packages', title: 'Therapy Packages' },
  { id: 'other', title: 'Other' },
]

export const CLINIC_APPOINTMENT_TYPES_ARRAY = [
  CLINIC_APPOINTMENT_TYPES.consultation,
  CLINIC_APPOINTMENT_TYPES['therapy-session'],
  CLINIC_APPOINTMENT_TYPES['therapy-packages'],
  CLINIC_APPOINTMENT_TYPES.assessments,
  CLINIC_APPOINTMENT_TYPES.other,
]
export const CLINIC_SERVICES_ITEMS_TYPES = {
  single: { id: 'single', title: 'Single' },
  bundle: { id: 'bundle', title: 'Multiple' },
}

export const CLINIC_SERVICES_ITEMS_TYPES_ARRAY = [
  CLINIC_SERVICES_ITEMS_TYPES.single,
  CLINIC_SERVICES_ITEMS_TYPES.bundle,
]

export const DRUG_TABLE_COLUMN_WEIGHTS = {
  // type was 0.6 — too narrow once the taper "+" button shares the cell, so the
  // value (TAB/CAP/SYRUP/INJECTION…) wrapped onto multiple lines. Widened so it fits
  // on one line. NOTE: only the EDITOR table renders the 'type' column; the print
  // tables exclude it from their visible set, so this does not change print widths.
  type: 1.1,
  drug_name: 2,
  dosage: 1.3,
  when: 1,
  frequency: 1,
  duration: 1,
  notes: 1.5,
  // Combined Frequency + When column in the printed/preview default table:
  // frequency in bold with the timing in regular font below it.
  freqWhen: 1.5,
  // Remarks column in the printed/preview Rx table carries the patient-friendly
  // sentence (+ any doctor note), so it is wide. Only the default table uses it.
  remarks: 2.4,
  // Computed Quantity column (dose × doses-per-day × duration-in-days) for the
  // quantity-bearing table presets.
  quantity: 1.1,
  hpConsolidatedColumn: 3,
}

export const DIAGNOSIS_SUB_SECTION_IDS = {
  diagnosis_title: {
    id: 'diagnosis_title',
    title: 'Diagnosis Title',
  },
  diagnosis_for_duration: {
    id: 'diagnosis_for_duration',
    title: 'Diagnosis Duration',
  },
  diagnosis_since_date: {
    id: 'diagnosis_since_date',
    title: 'Diagnosis Since Date',
  },
}

export const DIAGNOSIS_TABLE_COLUMN_WEIGHTS = {
  diagnosis_title: 2,
  diagnosis_for_duration: 1,
  diagnosis_since_date: 1,
}

// Optional clinical status for a diagnosis entry. Stored as `status` (one of the ids below,
// or unset). `printLabel` is what appears in the prescription (paper + PDF), e.g. "(Status: Ruled Out)".
export const DIAGNOSIS_STATUS_OPTIONS = [
  { id: 'ruled_out', label: 'Ruled out', printLabel: 'Ruled Out', color: '#64748b' },
  { id: 'suspected', label: 'Suspected', printLabel: 'Suspected', color: '#d97706' },
  { id: 'confirmed', label: 'Confirmed', printLabel: 'Confirmed', color: '#059669' },
]

export const DIAGNOSIS_STATUS_MAP = DIAGNOSIS_STATUS_OPTIONS.reduce((acc, option) => {
  acc[option.id] = option
  return acc
}, {})

// Optional severity for a complaint entry. Stored as `severity` (one of the ids below, or unset).
export const COMPLAINT_SEVERITY_OPTIONS = [
  { id: 'mild', label: 'Mild', printLabel: 'Mild', color: '#059669' },
  { id: 'moderate', label: 'Moderate', printLabel: 'Moderate', color: '#d97706' },
  { id: 'severe', label: 'Severe', printLabel: 'Severe', color: '#dc2626' },
]

export const COMPLAINT_SEVERITY_MAP = COMPLAINT_SEVERITY_OPTIONS.reduce((acc, option) => {
  acc[option.id] = option
  return acc
}, {})

export const BOOKING_SESSION_STATUS = {
  NOT_STARTED: 'not-started',
  IN_PROGRESS: 'in-progress',
  MARKED_COMPLETED: 'marked-completed',
  FINISHED: 'finished',
  CANCELLED: 'cancelled',
}

export const BOOKING_SESSION_STATUS_MAP = {
  'not-started': { id: 'not-started', title: 'Not Started' },
  'in-progress': { id: 'in-progress', title: 'In Progress' },
  'marked-completed': { id: 'marked-completed', title: 'Marked Completed' },
  finished: { id: 'finished', title: 'Finished' },
}

export const BOOKING_STATUSES = {
  BOOKED: 'booked',
  BOOKING_INITIATED: 'booking-initiated',
}
export const BOOKING_PAYMENT_STATUSES = {
  PAID: 'paid',
  PENDING: 'pending',
}

export const PAYMENT_GATEWAYS = {
  RAZORPAY: 'razorpay',
  STRIPE: 'stripe',
}

export const SIGNALING_COMMANDS = {
  SHOW_THERAPY_SUPPORT_WHATSAPP_QR_FOR_30_SECONDS:
    'show-therapy-support-whatsapp-qr-for-30-seconds',
  SHOW_PAYMENT_QR_FOR_30_SECONDS: 'show-payment-whatsapp-qr-for-30-seconds',
  ASK_NEXT_ACTION_NOW: 'ask-next-action-now',
  JOIN_AGORA_CHANNEL_AND_START_VIDEO: 'join-agora-channel-and-start-video',
  SHOW_BOOKING_PAYMENT_LINK_QR_WITH_PATIENT_DETAILS:
    'show-booking-payment-link-qr-with-patient-details',
  CLEAR_ROOM_SCREEN: 'clear-room-screen',
  QR_PAYMENT_SUCCESS: 'qr-payment-success',
  REFRESH_ROOM_SCREEN: 'refresh-room-screen',
  ANY_IMAGE: 'any-image',
  DEREGISTER_SCREEN_AND_RELOAD_APP: 're-register-unregistered-screen',
  BULK_DEREGISTER_SCREEN_AND_RELOAD_APP: 'bulk-re-register-unregistered-screen',
  REFRESH_BOOKINGS: 'refresh-bookings',
  // Mentor portal signals
  USER_CHECKED_OUT: 'mentor.user-checked-out',
  VIDEO_CALL_STARTED: 'mentor.video-call-started',
  CHECKIN_REQUEST: 'emr-checkin-request-raised',
  CHECKIN_REQUEST_LEGACY: 'mentor.checkin-request',
  CHECKIN_REQUEST_CREATED_LOCAL: 'emr-checkin-request-created-local',
  CHECKIN_REQUEST_DENIED: 'emr-checkin-request-denied',
  CHECKIN_REQUEST_ROOM_AVAILABLE: 'emr-checkin-request-room-available',
  CHECKIN_REQUEST_COUNTDOWN_STARTED: 'emr-checkin-checkout-countdown-started',
  FORCED_CHECKOUT: 'emr-checkin-forced-checkout',
  SUPPORT_WHATSAPP_THREAD_UPDATED: 'support.whatsapp-thread-updated',
}

// The four selectable medication-table presets. They share one table renderer,
// parameterized along three dimensions:
//   - border style:  boxed (full grid) vs open (horizontal rules only)
//   - quantity:      whether a computed Quantity column is shown
//   - remarks:       shown as its own column vs as a full-width sub-row per medicine
//
//   default        → boxed,  no quantity, remarks as a COLUMN
//   boxedQty       → boxed,  quantity col, remarks as a SUB-ROW
//   openQty        → open,   quantity col, remarks as a SUB-ROW
//   openQtyRemarks → open,   quantity col, remarks as a COLUMN
//
// These four are the TABLE styles (the old "HP" table family). The other two
// rendering modes are non-table: `list` and `paragraphList`.
// Legacy value `HP` is normalized to `default` (the table) at render time
// (see PrescriptionDrugAdviceTable) so previously-saved selections keep working.
export const DRUG_ADVICE_TABLE_TYPES = {
  // ---- Table styles ----
  default: {
    id: 'default',
    title: 'Default Table',
    description: 'Boxed grid with a Remarks column (Medicine, Dose, Frequency, Duration, Remarks)',
    previewImageId: 'MEDIA-48de2a0e6f2a40adb4b5abb7531929ee',
  },
  boxedQty: {
    id: 'boxedQty',
    title: 'Boxed Table with quantity column',
    description: 'Boxed grid with a computed Quantity column; remarks shown as a sub-row',
    previewImageId: null,
  },
  openQty: {
    id: 'openQty',
    title: 'Open Table with quantity column',
    description: 'Open grid (horizontal rules only) with a Quantity column; remarks as a sub-row',
    previewImageId: null,
  },
  openQtyRemarks: {
    id: 'openQtyRemarks',
    title: 'Open Table with quantity & remarks column',
    description: 'Open grid (horizontal rules only) with both a Remarks column and a Quantity column',
    previewImageId: null,
  },
  // ---- Non-table rendering modes ----
  list: {
    id: 'list',
    title: 'List',
    description: 'Each drug on its own line (point-list format, not a table)',
    previewImageId: null,
  },
  paragraphList: {
    id: 'paragraphList',
    title: 'Paragraph',
    description: 'Each drug as a compact paragraph with typographic emphasis',
    previewImageId: null,
  },
  // ---- legacy id kept for back-compat normalization (not shown in selectors) ----
  HP: {
    id: 'HP',
    title: 'HP (legacy → Default Table)',
    description: 'Legacy consolidated column. Now renders as the Default Table.',
    previewImageId: 'MEDIA-8f1980c34ea544b4af37e6e26caa85fe',
  },
}

// User-selectable rendering modes: four Table styles + List + Paragraph. HP is excluded.
export const DRUG_ADVICE_TABLE_TYPES_ARRAY = [
  DRUG_ADVICE_TABLE_TYPES.default,
  DRUG_ADVICE_TABLE_TYPES.boxedQty,
  DRUG_ADVICE_TABLE_TYPES.openQty,
  DRUG_ADVICE_TABLE_TYPES.openQtyRemarks,
  DRUG_ADVICE_TABLE_TYPES.list,
  DRUG_ADVICE_TABLE_TYPES.paragraphList,
]

// Ids the renderer understands directly; anything else (e.g. legacy 'HP') → 'default'.
export const SELECTABLE_DRUG_ADVICE_TABLE_TYPE_IDS = [
  DRUG_ADVICE_TABLE_TYPES.default.id,
  DRUG_ADVICE_TABLE_TYPES.boxedQty.id,
  DRUG_ADVICE_TABLE_TYPES.openQty.id,
  DRUG_ADVICE_TABLE_TYPES.openQtyRemarks.id,
  DRUG_ADVICE_TABLE_TYPES.list.id,
  DRUG_ADVICE_TABLE_TYPES.paragraphList.id,
]
